export default {
    global: {
        noLimit:
            "You are not authorized to perform this action, please contact your administrator."
    },
    operations: {
        operate: "Operations",
        more: "More",
        turn_on: {
            name: "Start Up",
            tip: "Only support in shutdown status"
        },
        turn_off: {
            name: "Shutdown",
            tip: "Only support in running status"
        },
        restart: {
            name: "Reboot",
            tip: "Only support in running status"
        },
        reset_password: {
            name: "Reset Password",
            tip: "Only support in shutdown status"
        },
        rename: {
            name: "Edit instance name",
            tip: ""
        },
        reinstall: {
            name: "Reinstall System",
            tip: "Only support in shutdown status"
        },
        bandwidth: {
            name: "Adjust Bandwidth of Public Network",
            tip: "Only support in shutdown/running status",
            tip_public_ip: "Support public IP instances only"
        },
        sos: {
            name: "SOS",
            tip: null
        },
        fixsos: {
            name: "Fix SOS",
            tip: null
        },
        renew: {
            name: "Renew",
            tip: null
        },
        edit_tag: {
            name: "Edit Tag",
            tip: "Only support in shutdown/running status"
        },
        turnOnDeleteProtect: {
            name: "Enable instance deletion protection",
            tip:
                "Instance deletion protection cannot be enabled for an instance that has arrears. Please renew it and try again.",
            prepaidTip: "Only support  instances pay by configuration."
        },
        turnOffDeleteProtect: {
            name: "Turn off instance deletion protection",
            tip: "已欠费的实例无法开启实例删除保护，请续费后尝试"
        },
        delete: {
            name: "Delete",
            tip: "Monthly package resources are not allowed to be deleted",
            tipWithIPv6:
                "This instance cannot be deleted. Please disable the IPv6 bandwidth",
            tipWithRemoveProtect:
                "Instance deletion protection has been turned on, and deletion cannot be performed. Please turn off instance deletion protection and try again.",
            tipWithStatus: "Only support in shutdown status"
        }
    },
    speechCraft: {
        listEmptyText:
            "Please re-query when no data is available or no relevant data is found",
        listNoText: "No data is available",
        customList: "Please select up to 10 information items to display."
    },
    retailInstance: {
        text: {
            retailInstanceNet: "Retail Middle-End Network",
            extensionIntraNetIp:
                "Automatic setting is not supported for the secondary interface",
            contactTip: "Please contact Dongdong Group",
            batchClose: "Batch Shutdown",
            batchOpen: "Batch Start",
            batchRestart: "Batch Reboot",
            batchRepassord: "Reset passwords in batches",
            batchRename: "Edit instance name in batches",
            batchDelete: "Delete in batches",
            search: "Search",
            example: "E.g. cps.c2.perf1.memory",
            downloadSuccess:
                "Operation succeeded. It is downloading. Please wait",
            empty: "No instance type available",
            downloadShow: "Export instance",
            downloadRange: "Scope of export",
            downloadAll: "Export all instances",
            downloadSelect: "Export selected instances",
            downloadSearch: "Export search result",
            chooseInfo: "You have selected {0} instances",
            systemDataPartitions: "Total capacity of system disk",
            mountpoints: "Mounting point",
            capacity: "Capacity",
            fileSystem: "File system",
            addPartition: "Add partitions",
            dataDiskPartition: "Data disk partition",
            allRemainingSpace: "Total remaining space",
            emptyPartition: "No partitions",
            partitions: "partitions"
        },
        tooltip: {
            networkQuantityTip1:
                "Bond mode is used by default for JD Mall retail middle-end server. Dual mode is used for certain business scenarios. Please confirm if dual mode is required for your business scenario.",
            networkQuantityTip2:
                "If dual mode is used, automatic setting is supported for the primary interface only, not for the secondary interface. Please contact Dongdong Group",
            chooseTips: "Please select resource",
            turnOff: "You can only shut down started instances",
            turnOn: "You can only start shut-down instances",
            restart: "You can only reboot started instances",
            repassword: "The password can be reset for the off instance only",
            delete:
                "Only the Cloud Physical Server which is off and paid by configuration can be deleted",
            knowAboutFee:
                "I know about the cost and agree to delete all associated resources on my own",
            maxNum:
                "The maximum purchase quantity of a single order is 100; if expansion is needed, please contact customer service or "
        },
        help: {
            sizeFormatError: "only supports numbers",
            morePartitionPart2: "partition(s) can be added",
            only5partitions:
                "Supports up to {0} partitions, and other partitions can be set in the system after the system is installed"
        }
    },
    list: {
        searchPlaceholder: {
            id: "Please enter ID to search",
            name: "Please enter the name for searching",
            privateIp: "Please enter the Private IP address for searching"
        },
        id: "ID/Instance Name",
        region: "Availability Zone",
        ip: "IP Address",
        netWorkType: "Network Type",
        status: "Status",
        specifications: "Specifications",
        config: "Configuration",
        chargeInfo: "Billing Type",
        operation: "Operations",
        moreRegion: "More regions",
        searchresult1:
            "Find {0} resource matching the search and filter criteria, please change the search keywords or ",
        searchresult2:
            "Find {0} resource matching the search and filter criteria, please",
        backTolist: "go back to the list",
        fuzzySearchTip:
            "Fuzzy search: support the single condition research only, press the Enter key to generate a search term",
        exactSearchTip:
            'Advanced search: separate several condition values with ",", press the Enter key to generate a search term',
        IPsearchTip:
            'Retrieve the primary IP address of instance; separate them with ",", and press the Enter key to generate a search term ',
        mutisearchTip:
            "Support keyboard operation: press Tab key to check, press the Esc key to cancel, and press the Enter key to confirm",
        fuzzySearch: "Fuzzy Search",
        exactSearch: "Advanced Search",
        keySearch:
            "ID/Intranet IPv4/name will be automatically matched for search",
        keySearchTip:
            "如If no search conditions are specified, the host machine ID or Intranet IPv4 address will be automatically matched with first priority according to the entered features. If no features are matched, the search will be made by names."
    },
    text: {
        title: "JD Cloud Console",
        cancel: "Cancel",
        confirm: "OK"
    },
    create: {
        text: {
            createKeys: "Create Key Pair",
            loginMethods: "Login Method",
            key: "Key pair",
            keyPair: "Key pair",
            keyTips:
                "If not associated with SSH, it cannot log in to OS or access SOS out-of-band console through key pair!",
            publicKey: "Key Login",
            advanced: "Advanced Settings",
            hasBase64: "The following inputs adopted base64 codes",
            setPassword: "Set Password",
            customizedPassword: "Custom Password",
            autoPassword: "Automatically Generated Password",
            linkSSHKey: "Associated SSH Key Pair",
            shopping: " In Purchase",
            makeCps: "Create Cloud Physical Server",
            buyMustKnow: "Purchase Notes",
            yearlyOrMonthly: "Monthly Package",
            byConfigurations: "Pay By Configuration",
            byQuantities: "按用量",
            sale: "Sale",
            regionAndAz: "Region and Availability Zone",
            region: "Region",
            az: "Availability Zone",
            spec: "Type",
            cpsType: "Categories",
            mirror: "Image",
            mirrorType: "Image Type",
            os: "Operating System",
            osVersion: "System Version",
            application: "Application Program",
            storage: "Storage",
            sysDisk: "System Disk",
            sysDiskCapacity: "Total capacity of system disk",
            sysDiskCapacityUnitTip:
                "GiB is the binary capacity unit used by the operating system, while GB is the decimal capacity unit used by the hardware manufacturer 	",
            defaultPartitionModes: "Default partition ",
            customPartitionModes: "Customized partition ",
            lastCustomPartition: "Last install system partition parameters",
            dataDisk: "Data Disk",
            dataDiskCapacity: "Total capacity of data disk",
            net: "Network",
            netType: "Network Type",
            privateNet: "Internal Network",
            firewall: "Firewall",
            bandwidth: "Bandwidth",
            publicIp: "Public IP",
            bandCal: "Billing by Bandwidth",
            banCalModel: "Charge Mode",
            fixedBandwidthPrepaid: "Pay by fixed bandwidth-monthly package",
            fixedBandwidthPostpaid:
                "Pay by fixed bandwidth-pay by configuration",
            line: "IP Provider",
            bandLimit: "Bandwidth",
            aleadyJoinSharedBandwidth: "Added to the shared bandwidth",
            createBandwidth: "A new shared bandwidth will be built",
            baseInfo: "Basic Information",
            name: "Name:",
            desc: "Description:",
            username: "User Name",
            password: "Password",
            passwordConfirm: "Confirm Password",
            buyNum: "Quantity",
            buyNo: "Quantity",
            buyTimeSpan: "Duration:",
            buySpan: "Duration",
            count: "Quantity",
            selectedConfig: "Selected Configuration",
            cost: "Cost",
            server: "Server",
            mainEip: "Primary network interface EIP",
            extensionEip: "Secondary network interface EIP",
            original: "Original Amount",
            auto: "Auto-assign Public IP",
            root: "root",
            month: "month | months",
            yearUnit: "year | years",
            year: "1 year",
            twoYears: "2 years",
            threeYears: "3 years",
            memory: "Memory",
            netCard: "Network Interface",
            basic: "Basic Network",
            info: "Notification",
            caution: "Note",
            readAgree: "Read and Agree",
            confirm: "OK",
            cancel: "Cancel",
            save: "Save",
            standardImage: "Standard Image",
            standardAppImage: "Standard Image + Application",
            buyNow: "Buy Now",
            payNow: "Pay Now",
            range: "Range",
            calculating: "Calculating...",
            paying: "Paying",
            specType: "Instance Type",
            cpu: "CPU",
            gpu: "GPU",
            series: "Series",
            soldOut: "Sold Out",
            hostName: "HostName:",
            computeType: "Compute Type",
            storageType: "Storage Type",
            gpuType: "GPU Type",
            autoVpc: "Purchase the Elastic IP",
            autoVpcTip:
                "Purchase of Elastic IP is not necessary temporarily, you may purchase and" +
                " associate Elastic IP after creation of the Cloud Physical Server.",
            autoJoinShareBandwidth:
                "Once the Elastic IP is added to and then removed from the Shared Bandwidth, an exclusive bandwidth, paid by configuration, shall be automatically assigned to the Elastic IP (bandwidth: 1Mbps) and billed.If the Elastic IP is no longer in use, it is recommended to delete it as soon as possible",
            currentDeviceType: "Selected Instance Type:",
            customData: "User data",
            autoRenew: "Auto-renewal",
            autoRenewTip:
                "Resources (pay in advance) will be automatically renewed before maturity if there is sufficient balance in your account. The renewal duration is as long as that in this order.",
            uploadText: "In text form",
            uploadFile: "In file form",
            chooseFile: "Select a file",
            yearPackage:
                "The monthly package of current configuration is sold at only ￥{0}/month",
            feePerHour: "¥{0}/hour",
            monthPay: "(totally￥{0}/month)",
            configureMonthPay: "",
            openIpv6WithoutVpcTip:
                "IPv6 is not enabled for the selected private network. Please",
            openIpv6WithoutSubnetTip:
                "IPv6 is not enabled for the selected subnet. Please",
            openIpv6WithoutVpcTip1:
                "IPv6 is not enabled for the selected private network",
            openIpv6WithoutSubnetTip1:
                "IPv6 is not enabled for the selected subnet",
            allotPrivateIpv6: "Assign Private IPv6",
            relativeNetworkInterface: "Associated Network Interface",
            internetAccessType: "Network Interface Count",
            singleInternetAccess: "Single Network Interface",
            doubleInternetAccess: "Double Network Interfaces",
            targetInternetAccessName: "Target Network Interface Name",
            singleInternetAccessChiefName: "Primary Network Interface (bond0)",
            chiefInternetAccessName: "Primary Network Interface (eth0)",
            subInternetAccessName: "Secondary Network Interface (eth1)",
            networkQuantityAndName: "Network Count and Name",
            networkQuantity: "@:eip.text.internetAccessType",
            networkName: "Network Interface Name",
            singleInternetAccess: "@:eip.text.singleInternetAccess",
            doubleInternetAccess: "@:eip.text.doubleInternetAccess",
            singleInternetAccessChiefName:
                "@:eip.text.singleInternetAccessChiefName",
            chiefInternetAccessName: "@:eip.text.chiefInternetAccessName",
            subInternetAccessName: "@:eip.text.subInternetAccessName",
            chiefAndSubInternetAccessName:
                "@:eip.text.chiefInternetAccessName,@:eip.text.subInternetAccessName",
            networkAndBandWidth: "Network Interface and Bandwidth Settings",
            securityNetwork: "Security Settings"
        },
        tooltip: {
            keyPairTips:
                "Currently, it only supports the key pair association when the cloud physical server is created/reinstalled, and only when the SSH key pair is enabled and set correctly can the SOS out-of-band console be accessed",
            keyPairTip:
                "Currently, it only supports the key pair association when the cloud physical server is created/reinstalled. If only the key pair login is selected, the user needs to manually change the password to access the SOS out-of-band console.",
            publicKeyTip:
                "The key pair is composed of the public key and private key files. If you have chosen the key login method, we will disable login via user name and password by default.",
            loginTip:
                "Automatically Generate Password: If Automatically Generate Password is selected, the system-generated password will be sent by SMS and email. Please note to check. Key pair login: Currently, it only supports the key pair association when the cloud physical server is created/reinstalled. If only the key pair login is selected, the user needs to manually change the password to access the SOS out-of-band console.",
            loginTips:
                "Key pair login: Currently, it only supports the key pair association when the cloud physical server is created/reinstalled. Automatically Generate Password: If Automatically Generate Password is selected, the system-generated password will be sent by SMS and email. Please note to check.",
            customData:
                "It is used for configuring instances during start and is executed only when the instance system is started for the first time. If several instances are started at one time, user data are available for all instances.",
            setPasswordTip:
                "If the automatic production of password is selected, the password produced by the system will be sent via SMS and emails. Please remember to check it.",
            region:
                "Resources in different regions cannot communicate through the private network .Cannot modify the region after creation.",
            az:
                "As the intranets of different availability zones's resources do not connect with each other, they cannot be changed once created.",
            sysDisk:
                "If the system disk comprises a hard disk, it is automatically configured with NO" +
                " RAID. If the system disk comprises two hard disks, it will be automatically configured" +
                " with RAID1.",
            systemPartition:
                "When the system disk is in the NO RAID mode, the operating system can be only installed on one hard disk. In such case, the customizable partition capacity displayed is the hard disk capacity.",
            netTypeWarning:
                "Only one intranet can be created in one availability zone, the intranets created in different availability zones are not connected to each other by default.",
            netType:
                "Only one intranet can be created in one availability zone, the intranets created in different availability zones are not connected to each other by default. If connection of different intranets is needed, please submit application in the ticket system and wait for response based on evaluation by network specialists.",
            internalNet:
                "The user can only configure the intranet segment when creating the first Cloud Physical Server in the same availability zone, and the intranet segment cannot be modified upon being created. It is suggested that the user shall well make the network plan before creating the Cloud Physical Server.",
            internalNetDisabled:
                "The user can only configure the intranet segment when creating the first Cloud Physical Server in the same availability zone, and the intranet segment cannot be modified upon being created. The Cloud Physical Server purchased subsequently shall use the intranet segment by default. In case all Cloud Physical Servers of the user under the availability zone are recycled, the intranet segment can be configured again when purchasing the first Cloud Physical Server for another turn. It is suggested that the user shall well make the network plan before creating the Cloud Physical Server.",
            auto:
                "Public IP is bound with the Cloud Physical Server and cannot be unbound. The validity period is the same as the machine’s. The bandwidth configuration can be upgraded but not downgraded.",
            cal:
                "For the users purchasing EIP of fixed bandwidth type, billing by bandwidth upper limit will be designed according to their selected public network with the unit of Mbps, which suits the business scene with more stable network situation.Once the fixed bandwidth is purchased and added to the Shared Bandwidth, the bandwidth shall not be charged separately. The billing will be made by the Shared Bandwidth, remarkably saving the cost.",
            detail: "Detailed Introduction",
            line: "{0} network can provide higher access speed.",
            notEnough:
                "The machine type you currently select is short of inventory. You may select other types,",
            soldOut: "Sold out.You may select other resources ",
            cusService: "or contact customer service 400-615-1212,or ",
            ticket: "open ticket.",
            oneYearDiscount:
                "17% off for One-year Cloud Physical Server service",
            twoYearDiscount:
                "17% off for Two-year Cloud Physical Server service",
            threeYearDiscount:
                "17% off for Three-year Cloud Physical Server service",
            autoRenew:
                "You can modify the auto-renewal configuration after resources created.For monthly purchase, the automatic renewal period is 1 month; for annual purchase, the automatic renewal period is 1 year and there is automatic renewal discount available.",
            hasNoFile: "No file selected",
            networkQuantityTip:
                "Single network interface refers to logic network interface; dual network interface refers to physical network interface;",
            mainNetwork:
                "The instance network interface rate of 10GE will be changed to 20GE after the single network interface (bond0) mode is selected; the instance network interface rate of 25GE will be changed to 50GE after the single network interface (bond0) mode is selected",
            subNetwork:
                "eth0 refers to the name of the main ports in the operating system, while eth1 is the name of the auxiliary ports in the operating system.",
            joinShareBandwidth:
                "Once the Elastic IP is added to the Shared Bandwidth in monthly package, if the Shared Bandwidth instance is released due to no renewal when due, an exclusive bandwidth paid by configuration will be automatically assigned to the Elastic IP and billed. If the Elastic IP is not in use, please delete it as soon as possible."
        },
        help: {
            publicKeySetting: "For login via key, please refer to",
            spec:
                "Please select different virtual Cloud Physical Server specification according to specific business, please refer to ",
            detail: "Specification Details.",
            systemVersionSpec:
                "To achieve a better gaming experience, please go to the game server page",
            systemVersionDetail: "to create resources.",
            will: "Private IPs will be assigned in the ",
            distributeIp: " section, and ",
            numCps: " Cloud Physical Servers can be created at most.",
            firewall:
                "Intranets are all open,  Port 22 of public network is opened (remote SSH login)",
            reference: "Refer to the Operation Guide for firewall settings ",
            guide: "Operation Guide . ",
            ddos:
                "JD Cloud automatically offers you up to 2Gbps traffic protection for malicious attack for free",
            ddosVpcGuid: "Operation Guide .",
            ddosVpc:
                "JD Cloud automatically offers you up to 2Gbps traffic protection for malicious attack free of charge,please refer to the operation guide for access to Anti-DDoS Basic serivice.",
            name:
                "1-32 characters, only supports Chinese, numbers, capital and lowercase letters, English underline “_” and line-through “-”.",
            desc: "The length cannot exceed 256 characters.",
            password:
                '8-30 characters, and simultaneously including three types (Capital letters, lowercase letters, numbers or special characters ()`~!@#$%&*_-+=|{}[]:";\'<>,.?/)',
            publicIpNoConfirm: "Confirm not to buy public IP?",
            noPublicIp:
                "If you do not buy public IP, you will not be able to access Cloud Physical Server from public IP. It does not support to add public IP later.",
            maxNum:
                "The maximum purchase quantity of a single order is 5; if expansion is needed, please contact customer service or ",
            autoAllocate: "Automatically Allocate within the Section {0}",
            byBandwidth: "{0},{1}Mbps by bandwidth",
            bySharedBandwidth: "{0},{1}Mbps by Shared Bandwidth",
            noCertification:
                "You haven’t conduct the real-name verification, which is a must for purchasing the Cloud Physical Server; ",
            goCertificate: "go to verify",
            soldOut: "Sold Out.",
            restock: "Replenishing. ",
            contact:
                " Please contact customer service 400-615-1212 (7*24) for consulting, or",
            exceedQuota: "Exceeding purchase quota.",
            autoPublicIpv6: "System auto assign to public IPv6 address",
            autoIpv6: "Auto-assign a Public IPv6",
            enableIpv6: "Enable IPv6:",
            publicOpen: "Intranets are all open",
            mainName:
                "It contains 2-60 characters, with uppercase and lowercase letters, numbers and " +
                'line-through "-" supported. However, "-" cannot be used successively and cannot be used at the beginning or the end.',
            instanceName:
                "The instance name is the alias of the Cloud Physical Server and it can be " +
                "defined and set by the user. Upon the setting, the screening can be implemented by using " +
                "the alias from the list of the Cloud Physical Server. Where several Cloud Physical " +
                "Servers are purchased once, numbers in increasing order will be put after the set name " +
                "of each Cloud Physical Server by default to indicate the Cloud Physical Servers." +
                "Meanwhile, the sequence number substitute character can be inserted anywhere in the name, e.g. {{index}}, and at the time of creation, the substitute character will be replaced with the incremental sequence number, e.g. input IT{{index}}cloud and set the number to 3, and after creation, the names are IT1cloud,  IT2cloud and IT3cloud, respectively. ",
            hostName:
                "The host name is the computer name within the operating system of the Cloud " +
                "Physical Server and it can be defined and set by the user. Upon the production of the Cloud " +
                "Physical Server, you can view the name by logging into the Cloud Physical Server. " +
                "Where several Cloud Physical Servers are purchased once, numbers in increasing order " +
                "will be put after the set name of each Cloud Physical Server by default to indicate the " +
                "Cloud Physical Servers." +
                "Meanwhile, the sequence number substitute character can be inserted anywhere in the name, e.g. {{index}}, and at the time of creation, the substitute character will be replaced with the incremental sequence number, e.g. input IT{{index}}cloud and set the number to 3, and after creation, the names are IT1cloud,  IT2cloud and IT3cloud, respectively. ",
            EipExceedQuota: "Eip exceeding purchase quota!",
            CPSOverStock: "CPS exceeding purchase quota!",
            onlyOne:
                "If Customized is selected,creation of Cloud Physical Server in batch is not" +
                " available now",
            instanceNameRule:
                "It contains 2-128 characters, beginning with uppercase and lowercase" +
                ' letters or Chinese characters, and may contain numbers, ".", "_", ":" or "-".',
            instanceNameRule1:
                "It contains 2-128 characters, beginning with uppercase and lowercase" +
                ' letters or Chinese characters, and may contain numbers, ".", "_", ":" , "-" or "{}".',
            mainServerNameRule:
                "It contains 2-64 characters in length and can be segmented into " +
                "several" +
                " sections with the separator (.). Uppercase and lowercase letters, numbers or " +
                "hyphens (-)" +
                " can be used in each section, but the dot (.) or the hyphen (-) cannot be " +
                "continuously " +
                "used in each section. It cannot start or end with a dot (.) or a hyphen " +
                "(-).",
            aleadyJoinSharedBandwidth:
                "(Bandwidth:{0}Mbps,Additional Uplink Bandwidth:{1}Mbps)"
        },
        placeholder: {
            codeExample: "Example:\n #!/bin/bash \n echo 'hello world'\n",
            windowsCodeExample: "Example:\n rem cmd \n echo 'hello world'\n",
            customData:
                "Linux system supports bash and python both. Before encoding, be sure to use #!/bin/bash and #!/usr/bin/env python in the first line; please encode under the Linux environment to avoid incompatible formats and keep the original data not greater than 16KB.",
            windowsTips:
                "Windows system supports both bat and powershell. Before encoding, be sure to start with “rem cmd” in the first line, and set <powershell></powershell> in the first and last lines. Please encode under the Linux environment to avoid incompatible formats and keep the original data not greater than 16KB.",
            version: "Please select Version",
            application: "Select one application at least",
            fixedBandwidth: "By fixed bandwidth",
            enhanced95: "By Enhanced 95",
            nameNull: "The name cannot be blank",
            passNull: "The password cannot be blank",
            confirmPassNull: "Confirm that the password cannot be blank",
            passNotSame: "Confirmation password is inconsistent with password",
            passNotMeetRequire: "Password does not comply with requirements",
            passwordNotSame: "Passwords are inconsistent",
            mainName: "Optional, computer name within the operating system",
            ipAddressNotPass: "Please enter a valid IP address",
            ipAddressRepeat:
                "The IPv4 address overlaps another one or exceeds the IPv4 CIDR range of the subnet ",
            ipv6AddressNotPass: "Please enter a valid IPv6 address",
            subCidrNameNull: "Secondary CIDR cannot be null",
            certificateNull: "The certificate content cannot be blank",
            default: " "
        },
        error: {
            uploadFileFormatError:
                "The format of uploaded file is wrong, please upload again",
            uploadFileSizeError:
                "The size of uploaded file cannot be greater than 16KB",
            uploadFileBase64:
                'The contents of the current file have been encoded in base64, please check "the following inputs have been encoded in base64"',
            uploadFileNotBase64:
                'The contents of the current file have not been encoded in base64, please uncheck "the following inputs have been encoded in base64"'
        }
    },
    listPage: {
        speechCraft: {
            title: "Cloud Physical Server",
            helpDocument: "CPS Documentation",
            monitorTo: "Go to Monitoring to",
            alarmRules: " Set Alarm Rules",
            commitWorkSheet: "Click to open ticket",
            adjustPublicBandWidth: "Adjust bandwidth of public network",
            tipWaring:
                "Adjust the bandwidth configuration only supports upgrading, not downgrading. The adjustment will take effect immediately.",
            reInstallTipWaring:
                "Note: </br>" +
                "1、System reinstallation is for the initialization/changing" +
                " operating system of the system disk. </br>" +
                "2、This operation will clear the system disk data of the Cloud Physical Server, so please" +
                " back up; JD Cloud will take no liability for any data loss due to failure of backup. </br>" +
                "3、If you select to format the data disk, the data in the data disk will be cleared at the " +
                "same time. When the system is re-installed, the attached data disk needs to be loaded again..</br>",
            chooseMoreThanOne: "Select one application at least",
            passwordVerify: "The password cannot be blank",
            repasswordVerify: "Confirm that the password cannot be blank",
            passwordType:
                'Password: 8-30 characters, and simultaneously including three types (Capital letters, lowercase letters, numbers or special characters ()`~!@#$%&*_-+=|{}[]:";\'<>,.?/)',
            sureSame: "Confirmation password is inconsistent with password",
            simFormat: "Format all data disks simultaneously",
            reInstallTip:
                "Note: System reinstallation is for the initialization/changing operating system of the system disk. This operation will clear the system disk data of the Cloud Physical Server, so please back up; JD Cloud will take no liability for any data loss due to failure of backup. If the data disk is selected to be not reserved, the data disk will also be cleared simultaneously. Attached data disk needs to be uploaded again for the system reinstallation.",
            ReSureInstall:
                "Confirm to execute system reinstallation operation to: {0} Cloud Physical Server?",
            applicationTooltips: {
                Nginx:
                    "Nginx is a lightweight Web server/reverse proxy server and Email (IMAP/POP3) proxy server that is distributed under a BSD-like protocol and features less memory and stronger concurrency.",
                MySQL:
                    "MySQL is one of the most popular relational database management systems. MySQL is the best RDBMS (Relational Database Management System) application in terms of WEB application.",
                RabbitMQ:
                    "RabbitMQ is a reusable enterprise message system based on AMQP, it complies with the Mozilla Public License open source protocol."
            },
            confirmNet:
                "Adjust the bandwidth configuration only supports upgrading, not downgrading.",
            hostNameRule:
                "It contains 2-60 characters, with uppercase and lowercase letters, numbers" +
                ' and line-through "-" supported. However, "-" cannot be used successively and cannot be used at the beginning or the end.',
            dataFormattedRedWarning:
                "Data of data disks will be cleared at the same time",
            reinstallConfirmCheckWarning:
                "I confirm to select the mode {0} while formatting all data" +
                " disks, with data in these data disks cleared at the same time.",
            deleteInstanceTip:
                "Notes:  </br>" +
                "1. All data will be cleared and unrecoverable once the Cloud Physical Server is deleted. Please back up your data in advance; </br>" +
                "2. When the Cloud Physical Server is deleted, resources in the virtual server group of the Load Balancer will be deleted as well; but the associated elastic IP will be kept continuously. If you do not need to keep it, please go to the corresponding page to delete it, so as not to incur extra costs. </br>",
            sureCharge:
                "I am clear about the cost, and agree to delete all associated resources on my own ",
            deleteInstanceChecnkWarning:
                "Confirm to delete the Cloud Physical Server : {0}?"
        },
        placeholder: {
            choose: "Please select",
            chooseSystemOperate: "Please select Version.",
            currentPlaceholder: "Please enter the name for searching"
        },
        text: {
            create: "Create",
            public: "(public)",
            private: "(private)",
            error: "Error",
            run: "Running",
            shutdown: "Stopped",
            hasExpired: "Expired",
            created: "Created",
            expired: "Expiration",
            freed: "Release",
            cost: "Cost",
            price: "Original Amount",
            saving: "Save",
            cancel: "Cancel",
            currencySymbol: "￥",
            cancelButton: "Cancel",
            sureButton: "Ok",
            reInstallSystem: "Reinstall System",
            hostInformation: "Machine Information",
            hostNowInformation: "Current host information",
            maxBandWidth: "Bandwidth Upper Limit",
            exampleID: "Instance ID",
            exampleName: "Instance Name",
            powerIn: "Starting",
            shuttingDown: "Shutting Down",
            rebooting: "Rebooting",
            creating: "Pending",
            destroying: "Destructing",
            reconfiging: "Resizing",
            reinstalling: "Reinstalling System",
            standardImage: "Standard Image",
            imageAndApp: "Standard Image + Application",
            prepaid_by_duration: "Monthly Package",
            postpaid_by_duration: "Pay By Configuration",
            baseNet: "Basic Network",
            exportList: "Export Resource List",
            customList: "Edit Columns",
            unknown: "unknown",
            intermediate: "intermediateState",
            currentMirror: "Current Image",
            pubIpv4: "Public IPv4:",
            pubIpv6: "Public IPv6:",
            priIpv4: "Private IPv4:",
            publicIpv4: "(Public IPv4)",
            publicIpv6: "(Public IPv6)",
            privateIpv4: "(Private IPv4)",
            resettingPassword: "Resetting password",
            tags: "Tag",
            expirationDate: "New Expiration Time",
            delete: "Delete",
            targetIpAddressTip:
                "IP Address refers to the primary IP address of main instance network interface and the associated Elastic IP address",
            configTip:
                "The bandwidth cap is the EIP bandwidth associated with the primary IP of the primary instance internet access",
            deploymentRefundFee: "Allocation refund fee",
            deploymentSupplementFee: "Allocation and replenishment expenses",
        },
        tableLabel: {
            idOrName: "ID/Instance Name",
            availableArea: "Availability Zone",
            ipAddress: "IP Address",
            netType: "Network Type",
            status: "Status",
            specificationType: "Specifications",
            config: "Configuration",
            billingInformation: "Billing Type",
            name: "Name",
            publicIp: "Public IP",
            publicIpAddr: "Public IP Address",
            expireTime: "Expiration Time",
            currentBandWidth: "Current Bandwidth",
            billMethods: "Billing Method",
            systemDisk: "System Disk",
            mirroringType: "Image Type",
            operateSystem: "Operating System",
            systemVersion: "System Version",
            applicationSystem: "Application Program",
            mirroring: "Image",
            administrator: "Administrator",
            password: "Password",
            repassword: "Confirm Password",
            dataDisk: "Data Disk",
            operation: "Actions",
            hostName: "HostName",
            dataDiskType: "dataDiskType",
            dataDiskConfig: "dataDiskConfig",
            targetInternetIp: "IP of Target Intranet",
            chooseEip: "Select EIP",
            targetIpAddress: "Primary IP Address"
        },
        errorMessage: {
            params: "Parameters out of range"
        }
    },
    detail: {
        text: {
            diskReadWrite: "Disk Read/Write Traffic ",
            diskCountReadWrite: "Disk Read/Write IOPS ",
            networkTraffic: "Network Ingress/Egress Traffic ",
            networkPacket: "Network Ingress/Egress Packets ",
            rangeForSearch: "Select time range for search",
            diskUsed: "Disk partition Used",
            diskUtil: "Disk partition Usage",

            cpuUsed: "CPU使用率",
            memoryUsed: "内存使用率",
            memoryUtil: "内存使用量",
            tcPConnectionCount: "TCP总连接数",
            activeTCPConnections: "TCP正常连接数",
            totalProcessCount: "总进程数",
            oneMinuteLoadAverage: "平均负载1min",
            fiveMinuteLoadAverage: "平均负载5min",
            fifteenMinuteLoadAverage: "平均负载15min",
            gpuMemoryTotal: "GPU 总显存",
            gpuUtilization: "GPU 使用率",
            gpuMemoryUsed: "GPU 显存使用量",
            gpuMemoryUtilization: "GPU 显存使用率",

            rangeH: "{0}h",
            rangeD: "{0}d",
            timeRangeH: "h",
            timeRangeD: "d",
            rangeSeparator: " to ",
            renewals: "Renew",
            operate: "Operations",
            sourceInfo: "Resource Information",
            baseInfo: "Basic Information",
            id: "ID",
            name: "Instance Name",
            newName: "New instance name",
            modifyName: "Modify Name",
            cancel: "Cancel",
            sure: "OK",
            describe: "Description",
            modifyDescribe: "Modify Description",
            billingType: "Billing Type",
            createTime: "Creation Time",
            expireTime: "Expiration Time",
            region: "Region",
            availableArea: "Availability Zone",
            configurationInfo: "Configuration Information",
            mirroring: "Image",
            spec: "Specifications",
            systemDisk: "System Disk",
            dataDisk: "Data Disk",
            netInfo: "Network Information",
            intranetIp: "Private IP",
            onetSegment: "CIDR",
            firewall: "Firewall",
            publicNetIP: "Public IP",
            publicNetBandWidth: "Public Network Bandwidth",
            operationsGuide: "Operation Guide .",
            hardWareMonitor: "Hardware Monitoring",
            performanceMonitor: "Performace Monitoring",
            monitor: "Monitoring",
            device: "Device",
            statue: "Status",
            status: "Status",
            normal: "Normal",
            abnormal: "Exception",
            maxBandWidth: "Bandwidth Upper Limit",
            currentBandWidth: "Current Bandwidth",
            billingMethods: "Billing Method",
            cost: "Cost",
            price: "Original Amount",
            saving: "Save",
            currencySymbol: "￥",
            reInstallSystem: "Reinstall System",
            hostInformation: "Machine Information",
            mirroringType: "Image Type",
            operateSystem: "Operating System",
            systemVersion: "System Version",
            application: "Application Program",
            administrator: "Administrator",
            password: "Password",
            repassword: "Confirm Password",
            operation: "Operations",
            copySuccess: "Copied",
            powerIn: "Starting",
            shuttingDown: "Shutting Down",
            rebooting: "Rebooting",
            creating: "Pending",
            destroying: "Destructing",
            reconfiging: "Resizing",
            reinstalling: "Reinstalling System",
            error: "Error",
            run: "Running",
            shutdown: "Stopped",
            prepaid_by_duration: "Monthly Package",
            standardImage: "Standard Image",
            imageAndApp: "Standard Image + Application",
            "cn-east-1": "cn-east-1",
            "cn-north-1": "cn-north-1",
            "cn-east-1a": "AZ A",
            "cn-north-1b": "AZ B",
            "cn-north-1a": "AZ A",
            "cn-north-1c": "AZ C",
            memory: "Memory",
            netCard: "Network Interface",
            hardDisk: "Hard Disk",
            podName: "Net-POD",
            iloIp: "OOB IP",
            cabinet: "cabinet code",
            intermediate: "intermediateState",
            restart: "Reboot",
            graphics: "graphics",
            power: "power",
            other: "other parts",
            hardwareStatusList: "List of Hardware Device Status",
            hardwareStatus: "Hardware Device Status",
            warningLogList: "Alarm log list",
            warningLogNumber: "Alarm Log No.",
            warningTime: "Alarm time",
            warningLogContent: "Content of Alarm Log",
            netAccessDetail: "Network Interface Details",
            netAccessType: "Network Interface Type",
            publicNetIp: "Public IP",
            interNetIp: "Internal IP",
            ipType: "IP Type",
            bondedAliasIpRange: "Range of Associated Alias IPs(IPv4)",
            bondedIPv6AliasIpRange: "Range of Associated Alias IPs(IPv6)",
            primaryIp: "Primary IP",
            netAccessDetail: "Network Interface Details",
            netAccessType: "Network Interface Type",
            publicNetIpv4: "Public IPv4(Primary IP)",
            interNetIpv4: "Internal IPv4(Primary IP)",
            interNetIpv6: "Internal IPv6(Primary IP)",
            eipv6: "Public IPv6",
            typeIpv6: "IPv6 type",
            addressIpv6: "IPv6 address",
            monitorInstance: "Instance",
            monitorDisk: "Disk",
            monitorDiskPiece: "Disk partition",
            net: "Network interface",
            logid: "ID",
            alertType: "fault type",
            alertDesc: "fault description",
            eventTime: "Alarm Time",
            updateTime: "Update Time",
            count: "Alarm Frequency",
            alertStatus: "State",
            unhandled: "Unhandled",
            recovered: "Recovered",
            ignored: "Ignored"
        },
        speechCraft: {
            title: "Cloud Physical Server",
            helpDocument: "CPS Documentation",
            nameNoNull: "The name cannot be blank",
            editNameRule:
                "1-32 characters, only supports Chinese, numbers, capital and lowercase letters, English underline “_” and line-through “-”.",
            descriptionLongRule:
                "Description: The length cannot exceed 256 characters",
            fireWallDefault: "Default Linux Open Port 22",
            clickToCommit: "Click to open ticket",
            adjustPubNetBand: "Adjust Bandwidth of Public Network",
            publicNetTip:
                "Adjust the bandwidth configuration only supports upgrading, not downgrading. The adjustment will take effect immediately.",
            reInstallTip:
                "Note: System reinstallation is for the initialization/changing operating system of the system disk. This operation will clear the system disk data of the Cloud Physical Server, so please back up; JD Cloud will take no liability for any data loss due to failure of backup. If the data disk is selected to be not reserved, the data disk will also be cleared simultaneously. Attached data disk needs to be uploaded again for the system reinstallation.",
            moreThanOneTip: "Select one application at least",
            passwordVerify: "The password cannot be blank",
            password:
                'Password: 8-30 characters, and simultaneously including three types (Capital letters, lowercase letters, numbers or special characters ()`~!@#$%&*_-+=|{}[]:";\'<>,.?/)',
            repasswordVerify: "Confirm that the password cannot be blank",
            sureSame: "Confirmation password is inconsistent with password",
            simFormat: "Format all data disks simultaneously",
            sureReInstall:
                "Confirm to execute system reinstallation operation to:{sysName} Cloud Physical Server?",
            applicationTooltips: {
                Nginx:
                    "Nginx is a lightweight Web server/reverse proxy server and Email (IMAP/POP3) proxy server that is distributed under a BSD-like protocol and features less memory and stronger concurrency.",
                MySQL:
                    "MySQL is one of the most popular relational database management systems. MySQL is the best RDBMS (Relational Database Management System) application in terms of WEB application.",
                RabbitMQ:
                    "RabbitMQ is a reusable enterprise message system based on AMQP, it complies with the Mozilla Public License open source protocol."
            },
            reInstallSuccess: "System re-installed",
            confirmNet:
                "Adjust the bandwidth configuration only supports upgrading, not downgrading.",
            dickPieceTip:
                "Linux OS reports by MountPoint, and Windows OS reports by DriveLetter",
            dickTip:
                "Linux OS reports by DeviceName, and Windows OS reports by DriveLetter"
        },
        placeholder: {
            editName: "Edit Name",
            selectSystemVersion: "Please select Version."
        },
        errorMessage: {
            passwordRule: [
                "Password does not comply with requirements",
                "Passwords are inconsistent"
            ]
        }
    },
    popHelper: {
        speechCraft: {
            repasswordTip: "Password Resetting Notification",
            repasswordWaring: [
                "So sorry! Password resetting does not support on-line operation for now",
                "You may open ticket or contact customer service",
                " 400-615-1212 (7*24)"
            ],
            sureOpen: "Confirm to start up the Cloud Physical Server: {0}?",
            sureClose: "Confirm to shut down the Cloud Physical Server: {0}?",
            sureRestart: "Confirm to reboot the Cloud Physical Server: {0}?",
            stockNotEnough: "Insufficient inventory Notification",
            stockNotEnoughWaring: [
                "Sorry! The machine type you currently select is short of inventory.",
                "You may select other types or open ticket",
                " or contact customer service"
            ],
            userQuota: [
                "Exceed accumulative purchase quantity of the user",
                "Exceed accumulative purchase quantity of the user. Please adjust the purchase quantity."
            ],
            personalUser: [
                "Individual User Not Supported",
                "At present, the high discount promotion has not been opened to the certified individual user. Please wait for other promotions or upgrade to be the enterprise user in the user management page."
            ],
            onlyOne: [
                "Exceed purchase quantity limit",
                "Only 1 Cloud Physical Server can be purchased during the promotion."
            ],
            unpaidOrder: [
                "Orders Unpaid",
                "You have the order(s) unpaid. Please pay the orders in the order management page."
            ]
        },
        text: {
            sure: "OK",
            cancel: "Cancel",
            openSuccess: "Startup Succeeded",
            closeSuccess: "Shutdown Succeeded",
            restartSuccess: "Reboot Succeeded",
            submitSheet: "Open ticket"
        },
        title: {
            open: "Startup Notification",
            close: "Shut Down Notification",
            restart: "Reboot Notification"
        }
    },
    orderConfirm: {
        text: {
            orderConfirm: "Order Confirmation",
            payConfirm: "Payment Confirmation",
            payFinish: "Payment Completion",
            orderInfo: "Order Information",
            productType: "Product Type",
            configInfo: "Configuration Details",
            chargeType: "Billing Type",
            timeSpan: "Duration",
            number: "Count",
            fee: "Cost",
            currentConfig: "Current Configuration",
            afterConfig: "Configuration After Adjustment"
        },
        help: {
            forYourSafetyUse:
                "Cannot delete resources under monthly package berfore expiration time to ensure normal use. ",
            readAndAgree: "I have read and agreed to",
            cpsTerms: " Cloud Physical Server Terms",
            shouldPay: "Amount Payable:",
            original: "Original Amount:￥",
            save: "Save:￥"
        }
    },
    // 子网
    subnet: {
        text: {
            privateNetwork: "VPC",
            createPrivateNetwork: "Create VPC",
            cidr: "Main IPv4 CIDR",
            subCidr: "Secondary IPv4 CIDR",
            cidrAddress: "",
            cidrType: "",
            ipv6Cidr: "IPv6 CIDR",
            primaryIpv6Cidr: "Main IPv6 CIDR",
            vpcIpv6Cidr: "VPC IPv6 CIDR",
            subnetIpv6Cidr: "Major IPv6 CIDR of the subnet",
            create: "Create subnet",
            openIpv6: "Enable IPv6",
            name: "Name",
            netBelongTo: "VPC",
            availableIpToAllIp: "Available IP/Total IP(Main)",
            availableIpToAllIpSub: "Available IP/Total IPs (Secondary)",
            availableIpv6ToAllIp: "Available IPv6s/Total IPv6s(Main)",
            delete: "Delete",
            subnetCidr: "CIDR",
            privateIp: "Private IPv4",
            publicIp: "Public IPv4",
            addIpAliasRange: "Add alias IP range",
            ipAliasRange: "Alias IP Ranges",
            subnetRange: "Subnet Range",
            subnet: "Subnet",
            deleteSubnet: "Delete subnet",
            forExample: "For example:10.0.1.1/24 or /32",
            save: "Save",
            edit: "Edit",
            routeMap: "Route Table",
            defaultRouteMap: "Default Route Table",
            operationSuccess: "Operate successfully",
            addSubCidr: "Add secondary IPv4 CIDR",
            subCidrName: "Name of Secondary CIDR",
            mainCidr: "Primary IPv4 CIDR",
            mainIpv6Cidr: "Primary IPv6 CIDR",
            addSuccess: "Add successfully",
            noAvailableIpAddress: "No available IP address",
            noAvailableIpv6Address: "No available IPv6 address",
            allocacateSource: "Assignment Source",
            deleteAliasIp: "Delete alias IP range",
            ipAlias: "Alias IPv4",
            alreadyAllocateIpAliasRange: "Assigned Alias IP Ranges",
            deleteSubCidr: "Delete Primary CIDR",
            confirmToDeleteSubCidr:
                "Confirm to delete {0} ({1})? After deletion, it will be" +
                " disassociated with resources automatically.",
            ipv6Forexample: "Please enter the complete IPv6 CIDR"
        },
        help: {
            doc: "Help Documentation of Subnet",
            confirmToDelete: "Confirm to delete the subnet {0}?",
            vpcHasSubnetNo: "The existing VPC has",
            count: "subnet | subnets",
            cidr:
                "The count of resources created by a subnet will be affected by the entered masks of the same subnet",
            NoCidr: "No subnet CIDR available",
            cidrNotStandard: "Please enter legal and standard alias IP range",
            ipv6CidrStandard:
                "The alias IP range does not comply with the IPv6 address rule. Please reset it.",
            cidrIpv6OutOfRange:
                "The alias IP range does not fall in the main IPv6 CIDR of the subnet. Please reset it.",
            cidrIpv6OverLap:
                "There are overlaps between the alias IP range and the distributed IP address range in the subnet. Please reset it.",
            cidrOutOfRange:
                "Overlapping alias IP ranges or exceeding primary CIDR/secondary CIDR",
            cidrOverLap: "Overlapping alias IP ranges",
            cidrIsRetain:
                "2~254 are supported for the last place of alias IP range",
            moreAliasIpAvailablePart0:
                "Quantity of IP alias range to be added: ",
            moreAliasIpAvailablePart1:
                "Quantity of IP alias range to be added: Quantity of IP alias ranges IPv4 is",
            moreAliasIpAvailablePart2: "",
            moreAliasIpAvailablePart3: ", Quantity of IP alias ranges IPv6 is",
            appointIpAliasRange: "Please specify alias IP range within {0}",
            aliasIpCannotBeNull: "Alias IP range cannot be null",
            only10IpAliasForOneInstance:
                "Support addition of only 50 alias IP ranges under the same Network Interface",
            changeSubnetForAliasIpWarning:
                "If alias IP range is entered, once the selected VPC or subnet is switched again, all alias IP ranges will be cleared",
            confirmToDeleteIpAliasRange:
                "Confirm to delete alias IP range {0}? It will be" +
                " automatically disassociated with resources after deletion.",
            confirmToDeleteIpv6AliasRange:
                "Confirm to delete alias IP range {0}? It will be" +
                " automatically disassociated with resources after deletion. After being deleted, it will be automatically decoupled with the resource and the IPv6 address within the IP alias range will become unavailable.",
            moreSubCidrPart2: "more Secondary IPv4 CIDR",
            onlyOneSubCidr:
                "Support creation of only one secondary IPv4 CIDR under the same subnet",
            subCidrTipPart1:
                "1-32 characters, only supports Chinese, numbers, capital and lowercase letters, ",
            subCidrTipPart2: "English underline “_” and line-through “-”",
            addAliasSuccess:
                "Alias IP ranges successfully added are as follows:({0} pcs./piece(s))",
            addAliasFail:
                "Alias IP ranges of which addition failed are as follows:({0} pcs./piece(s))",
            enterSubCidr: "Please enter secondary IPv4 CIDR",
            enterSubCidrname: "Please enter secondary CIDR Name",
            onlyForCreateLocateIpAlias: "For creating an alias IP range only",
            quotaExceed: "Insufficient quota",
            subnetNetCannotBeNull: "Please select Subnet Range",
            usedDeleteNotAllowed: "The resource is used and cannot be deleted"
        },
        tooltip: {
            vpcIpv6Cidr: "IPv6 segment allocated by the system to VPC",
            ipv6CidrError: "Input range 0-f"
        },
        operations: {
            delete: {
                name: "Delete",
                tip:
                    "The subnet cannot be deleted. Please delete the resources in the subnet first"
            },
            enableipv6: {
                name: "Enable IPv6",
                tip: ""
            }
        }
    },
    // 弹性IP
    eip: {
        text: {
            eip: "Elastic IP",
            eipv4: "Elastic IPv4",
            apply: "Application",
            ipAddress: "IP Address",
            ipId: "IP ID",
            allAz: "All AZs",
            unBond: "Not associated",
            publicIdOrAddress: "EIP ID/Address",
            line: "ISP Line",
            bandwidth: "Bandwidth",
            bandwidthLimit: "Bandwidth Cap",
            bindSource: "Associate Resource",
            modifyBandwidth: "Modify Bandwidth",
            joinShareBandwidth: "Add to Shared Bandwidth",
            alreadyJoinedSharedBandwidth: "Added to the shared bandwidth",
            joinShareBandwidthTip:
                "After Elastic IP is added to shared bandwidth: </br>" +
                "1.the original bandwidth bandwidth value will become invalid and turn to the same value of the shared bandwidth; after addition, the bandwidth is {0} Mbps ;</br>" +
                "2.the original billing mode will become invalid and turn to the pure IP, without additional bandwidth cost;</br>" +
                "3.the Elastic IP in pay-in-advance monthly package does not support addition to shared bandwidth now;</br>",
            removeShareBandwidth: "Remove from Shared Bandwidth",
            removeShareBandwidthTip:
                "After Elastic IP is removed from shared bandwidth: </br>" +
                "1.the bandwidth cap before addition to shared bandwidth will be restored: {0} Mbps for the bandwidth, and {1} Mbps for the additional uplink bandwidth;</br>" +
                "2.the billing mode before addition to shared bandwidth will be restored: pay by configuration(By fixed bandwidth)",
            bandwidthPackage: "Shared Bandwidth",
            independentBandwidth: "Billing by Fixed Bandwidth",
            bonded: "Associated",
            applyPublicIp: "Apply for EIP",
            cpsEip: "EIP of Cloud Physical Server",
            cpsEipServiceItem:
                "《Service Terms of Elastic IP For Physical Cloud》",
            bindSourceInfo: "Associate Resource Information",
            applyTime: "Application Time",
            sourceType: "Resource Type",
            privateAddress: "Intranet Address",
            unbindPublicIp: "Disassociate Public IP",
            instanceType: "Instance Type Family",
            unbindSource: "Disassociate Resource",
            status: "Status",
            chooseSource: "Select Resources",
            sourceName: "Source Name",
            cps: " Cloud Physical Server",
            privateAddress: "Intranet Address",
            id: "ID",
            originalPrice: "Original Amount:￥ {0}",
            discountedPrice: "Save:￥ {0}",
            bandwidthCalMode: "Charge Mode",
            selectedIP: "Selected IP",
            selectIP: "Optional IP",
            buyNo: "Quantity",
            totalPerMonth: "(totally ¥ {0}/month)",
            feePerHour: "¥{0}/hour",
            targetInternetAccessName: "Target Network Interface Name",
            billInfo: "Billing Type",
            relativeNetworkInterface: "Associated Network Interface",
            internetAccessType: "Network Interface Count",
            singleInternetAccess: "Single Network Interface",
            doubleInternetAccess: "Double Network Interfaces",
            targetInternetAccessName: "Target Network Interface Name",
            singleInternetAccessChiefName: "Primary Network Interface (bond0)",
            chiefInternetAccessName: "Primary Network Interface (eth0)",
            subInternetAccessName: "Secondary Network Interface (eth1)",
            targetPrivateIpAddress: "Target Private IP Address",
            arrear: "In Arrears"
        },
        help: {
            doc: "Elastic IP Help Documentation",
            ipAddressSearch: "Please enter an IP address for search",
            ipIdSearch: "Please enter an IP ID for search",
            createRegion:
                "When creating an EIP of Cloud Physical Server, it can only be associated " +
                "with the Cloud Physical Server that is located in the same region. Once the EIP of Create" +
                " Cloud Physical Server is created, its attribute of region cannot be changed any more.",
            countLimitedByEid:
                "The count is limited by the quota of EIP of Cloud Physical Server",
            countTooltip:
                "Based on the configuration above, the count of EIP of Cloud Physical Server" +
                " can be created in batch.",
            quotaTooltip:
                "The quota of EIP of Cloud Physical Server in this region is full. Please open ticket to apply for quota expansion.",
            alreadyBond:
                "The current Cloud Physical Server has been associated EIP",
            confirmToUnbind:
                "Confirm to disassociate {0} from Cloud Physical Server {1}{2}?",
            confirmToUnbindSlb:
                "Confirm to disassociate {0} from Load Balancer {1}?",
            confirmToUnbindNat:
                "Confirm to disassociate the EIP {0} from the NAT Gateway {1}?",
            confirmToUnshare:
                "Confirm to remove the Elastic IP {0} from the shared bandwidth: {1} ?",
            byBandwidth: "{0} Mbps by bandwidth",
            byPublicBandwidth: "{0} Mbps by shared bandwidth",
            soldOut:
                "The quota of resources of the selected region is full, please switch the region or",
            openTicket: " open ticket",
            increaseLimit: " increase quota",
            paidByDurationDeleteNotAllowed:
                "Monthly package resources are not allowed to be deleted",
            shareDeleteNotAllowed:
                "Shared bandwidth associated is not allowed to be deleted",
            confirmToDeleteEip: "Confirm to delete elastic IP: {0}?",
            knowAboutFee:
                "I have clearly understood the cost issue and agree to delete the resource on my own",
            boundDeleteNotAllowed:
                "Cannot delete elastic IP, please first disassociate its associated resources",
            joinSharedBandwidthNotAllowedModify:
                "Bandwidth modification is not supported after EIP is added to Shared Bandwidth",
            joinSharedBandwidthNotAllowedRenew:
                "Renewal is not supported after EIP is added to Shared Bandwidth",
            paidByDurationJoinSharedBandwidthNotAllowed:
                "Resources in the billing type of Monthly Package cannot be added to the Shared Bandwidth",
            targetIpAddressSearch:
                "Please enter a Target IP Address address for search",
            noChargeInfo: "No billing information",
            bindNatDeleteNotAllowed: "Binding nat gateway does not allow deletion.",
            bandwidthSoldOut:
                "The elastic IP is out of stock. Please contact the customer service 400-615-1212 (7*24 hours) for consulting or",
            extraBandwidthSoldOut:
                "The additional uplink bandwidth of Shared Bandwidth has been sold out. Please contact the customer service 400-615-1212 (7*24 hours) for consulting or",
        },
        placeholder: {
            search: {
                ipAddress: "Please enter an IP address for search",
                ipId: "Please enter an IP ID for search",
                name: "Please enter name for search",
                privateAddress:
                    "Please enter the Private IP address for searching",
                privateIp: "Please enter the Private IP address for searching",
                id: "Please enter an ID for search"
            }
        },
        operations: {
            unbind: {
                name: "Disassociate Resource"
            },
            bind: {
                name: "Associate Resource"
            },
            modify: {
                name: "Modify Bandwidth"
            },
            renew: {
                name: "Renew"
            },
            joinshared: {
                name: "Add to Shared Bandwidth"
            },
            removeshared: {
                name: "Remove from Shared Bandwidth"
            },
            delete: {
                name: "Delete"
            }
        }
    },
    // 共享带宽
    sbw: {
        text: {
            sbw: "Shared Bandwidth",
            apply: "Application",
            ipAddress: "IP Address",
            sharedBandwidthName: "Name of Shared Bandwidth",
            sharedBandwidthId: "Shared Bandwidth ID",
            sharedBandwidthIP: "Shared Bandwidth IP",
            idOrName: "ID/Name",
            idOrAddress: "IP ID/Address",
            alreadyJoinIp: "IP added",
            name: "Name",
            addIp: "Add IP",
            addIpTip:
                "After IP is added to Shared Bandwidth: </br>" +
                "1. The original bandwidth value will become invalid and become the same as the Shared Bandwidth. After addition, the bandwidth is: {0} Mbps;</br>" +
                "2. The original billing mode will become invalid and turn to be the pure IP, without additional bandwidth cost;</br>" +
                "3. The Elastic IP in pay-in-advance monthly package does not support addition to Shared Bandwidth for the moment;</br>",
            chooseIpTip: "Please select Shared Bandwidth{0}IP to be Added",
            chooseIpTip0: "Please select Shared Bandwidth",
            chooseIpTip1: "IP to be Added",
            remainIpTip: "{0} IP(s) can be added to Shared Bandwidth now",
            remainIpTip0: "can be added to Shared Bandwidth now",
            remainIpTip1: "IP(s)",
            exceedTotalIpCountTip:
                "IPs added to Shared Bandwidth have reached the quota. Please",
            removeShareBandWidthEip:
                "Removing Elastic IP from Shared Bandwidth",
            prepaid: "By fixed bandwidth",
            postpaid: "pay by configuration",
            postUsage: "Charged by Enhanced 95",
            guaranteedPercentage: "Guaranteed percentage",
            byEnhanced: "Charged by Enhanced 95 {0}Mbps",
            feePerDay: "¥{0}/day"
        },
        help: {
            doc: "Help Documentation of Edge Shared Bandwidth",
            confirmToDeleteSbw: "Confirm to delete Shared bandwidth: {0}?",
            deleteSbwTip:
                "IP Shared bandwidth cannot be deleted. Please remove the added IP first.",
            addIpTip:
                "IPs added to the Bandwidth have reached the quota. Please open ticket to increase quota.",
            bandwidthSoldOut:
                "The bandwidth of Shared Bandwidth has been sold out. Please contact the customer service 400-615-1212 (7*24 hours) for consulting or",
            extraBandwidthSoldOut:
                "The additional uplink bandwidth of Shared Bandwidth has been sold out. Please contact the customer service 400-615-1212 (7*24 hours) for consulting or",
            bothSoldOut:
                "the bandwidth and additional uplink bandwidth have been sold out. Please contact the customer service 400-615-1212 (7*24 hours) for consulting or",
            unExceedMonth: "Pay by consumption resources that have not been used for a complete natural month cannot be deleted",
            payByEnhancedNotAllowedRenew: "Pay by consumption resources do not support renewal",
        },
        tooltip: {
            node: "Intranet resources of different nodes are not interconnected and cannot be modified upon creation",
            cal: "In the service process of Shared Bandwidth, configuration of bandwidth value can be changed at any time",
            name: "Refers to the name of Shared Bandwidth",
            count: "This count is subject to the Shared Bandwidth quota",
            countTooltip: "Based on the configuration above, the count of Shared Bandwidth can be created in batches",
            enhanced: "The purchase of shared bandwidth priced at Enhanced 95 is suitable for business scenarios with significant fluctuations in public network bandwidth traffic within a single day, measured in Mbps.",
        },
        operations: {
            addip: {
                name: "Add IP"
            },
            removeip: {
                name: "Remove from Shared Bandwidth"
            },
            modify: {
                name: "Modify Bandwidth"
            },
            edittag: {
                name: "Edit Tag"
            },
            renew: {
                name: "Renew"
            },
            name: "Edit Tag",
            delete: {
                name: "Delete"
            }
        }
    },
    //NAT网关
    nat: {
        text: {
            createNat: "Create NAT Gateway",
            nat: "NAT Gateway",
            helpDoc: "Help Documentation for NAT Gateway",
            natName: "NAT Name",
            natId: "NAT ID",
            name: "Name",
            specificationType: "Specifications",
            maxBandwidth: "Maximum bandwidth",
            bondedEip: "Associated EIP",
            adjustSpecification: "Adjust specification",
            currentSpecification: "Current specification",
            selectSpecification: "Adjustable specifications",
            small: "Small",
            middle: "Medium",
            large: "Large",
            xlarge: "Xlarge",
            choosedSpecification:
                " (The maximum SNAT connections are {0}; there is no limit to the maximum number of new SNATs)",
            snat: "Snat rule",
            addSnatRule: "Add snat rule",
            editSnatRule: "Edit snat rule",
            snatId: "ID",
            snatIp: "IP",
            snatRuleId: "Snat Rule ID",
            snatRuleGranularity: "Snat rule granularity",
            snatOriginalIp: "Source Network Segment/Source IP",
            belongServer: "Subnet/Server",
            eip: "Elastic IP",
            dnat: "Dnat rule",
            addDnatRule: "Add dnat rule",
            editDnatRule: "Edit dnat rule",
            dnatRuleId: "Dnat Rule ID",
            publicNetPort: "Public network port",
            priIpv4: "Private IPv4",
            privatePort: "Internal network port",
            supportProtocol: "支持协议",
            description: "Description",
            subnetGranularity: "Subnet granularity",
            serverGranularity: "Server granularity",
            customGranularity: "Custom granularity",
            subnetCidr: "Main IPv4 CIDR: {0}",
            subnetSecondaryCidr: ";Secondary IPv4 CIDR: {0}",
            server: "@:listPage.speechCraft.title",
            customCidr: "Custom network segment",
            portType: "port type",
            allPort: "All ports",
            specific: "Specific Port",
            boundRules: "Bound Rule",
            snat: "SNAT",
            dnat: "DNAT"
        },
        speechCraft: {
            deteteNatTip:
                "Deleting a NAT Gateway will disassociate its elastic EIP address. But this address will not be released from your account. If you no longer want to use the elastic EIP and be charged, please log into the Console as soon as possible to delete the resources ",
            sureDeleteNat: "Confirm to delete the NAT Gateway: {0}? ",
            bindEipCount1: "The current NAT Gateway can be associated with",
            bindEipCount2: "elastic EIP(s) ",
            natTip:
                "The NAT Gateway can be associated with at most 20 elastic EIPs of the same region",
            maxLinkTip:
                "Maximum SNAT connections: 50,000 for small, 200,000 for medium, 500,000 for large, and 1,000,000 for xlarge",
            maxNewTip:
                "Maximum number of new SNATs: No limit to NAT Gateways with different specifications",
            natTypeTip:
                "The maximum SNAT connections are affected by NAT Gateways with different specifications while the maximum number of new SNATs for NAT Gateways with different specifications is unlimited. The count of EIP(s) configured on the gateway limits the maximum number of NAT Gateway connections. Associated with a single EIP, the maximum NAT Gateway connections are 55,000; associated with multiple EIPs, the maximum NAT Gateway connections are 55,000xN.",
            limitEipTip:
                "A NAT Gateway can be associated with at most 20 EIPs. The number of EIPs associated with the current NAT Gateway has reached the upper limit",
            natlimit:
                ", The number of elastic EIPs associated with this NAT Gateway has reached the upper limit.",
            deleteSnatRuleTip: "Removing the Snat rule will result in the corresponding cloud physical server instance being unable to access the public network and cannot be restored. Please be cautious when doing so.",
            sureDeleteSnatRuleTip: "Are you sure to delete the SNAT rule?",
            sureDeleteDnatRuleTip: "Are you sure to delete the DNAT rule?"
        },
        operations: {
            bind: {
                name: "Associate Resource"
            },
            modify: {
                name: "Adjust specification"
            },
            renew: {
                name: "Renew"
            },
            delete: {
                name: "Delete"
            },
            edit: {
                name: "Edit"
            }
        },
        help: {
            natOverStock: "NAT exceeding purchase quota!",
            customCidr: "请输入合法且标准的自定义网段",
            snatRule: "Supports creating 50 SNAT rules under the same nat instance",
            dnatRule: "Supports creating 100 DNAT rules under the same nat instance"
        },
        placeholder: {
            snatIp: "Please enter IP for search",
            eip: "Please select a elastic IP address",
            notEip: "--No available elastic IP--",
            emptyInstance: "--No instance available--",
            server: "Please enter the instance target Internal IP address for search",
            customCidr: "示例:10.0.1.1/24 或/32",
        },
    },
    // 对等连接
    peering: {
        text: {
            connection: "peering link",
            create: "Create",
            peeringName: "peering connection name",
            peeringId: "peering connection ID",
            status: "Status",
            localTerminalInfo: "Local end information",
            oppositeTerminalInfo: "Opposite end information",
            name: "Name",
            localRegion: "Local end region",
            localVpc: "Local end VPC",
            localVpcIpv4Cidr: "Local end VPC IPV4 CIDR",
            localVpcIpv6Cidr: "Local end VPC IPV6 CIDR",
            oppositeAccountType: "Type of account of opposite end",
            sameAccount: "The same account",
            differentAccount: "Cross-account",
            sender: "Sender",
            receiver: "Receiver",
            oppositeAccountNumber: "Account of opposite end",
            oppositeRegion: "Region of opposite end",
            oppositeVpc: "VPC of opposite end",
            chooseOppositeVpc: "Please Select Opposite VPC",
            oppositeVpcIpv4Cidr: "Opposite end VPC IPV4 CIDR",
            oppositeVpcIpv6Cidr: "Opposite end VPC IPV6 CIDR",
            localRouteStrategy: "Route Policies(Local end)",
            oppositeRouteStrategy: "Route Policies(Opposite end)",
            bandWidth: "Bandwidth",
            constBandWidth: "By fixed bandwidth",
            free: "Free",
            noLimit: "No restriction",
            byBandwidth: "{0} Mbps Billing by Fixed Bandwidth",
            monthPay: "(The monthly charge by configuration is￥{0} in total)",
            exceedQuota: "Exceeding purchase quota.",
            createTime: "Creation Time",
            routeId: "Route ID/name",
            destination: "Target End",
            nextHopType: "Type of Next Hop",
            nextHop: "Next Hop",
            reject: "Refuse",
            accept: "Accept",
            delete: "Delete",
            paymentByInitiator: "Payable by Launching Party"
        },
        help: {
            doc: "peering Connection Help Documentation",
            hasNoCpsVip:
                "As the current account is not tagged, resources charged by configuration cannot be created",
            submitWorkOrder: " open ticket",
            applyCpsVip:
                "Please open ticket for applying for tagging and then create a peering connection",
            acceptConnect:
                "The account of opposite end needs to accept the request before {0}",
            ipv4CidrIsOverlap:
                "Repeated VPC CIDR for new peering, connection failed"
        },
        placeholder: {
            search: {
                peeringName:
                    "Please enter the peering connection name for search",
                peeringId: "Please enter the peering connection ID for search"
            },
            oppositeVpcId: "Please enter VPC ID of the opposite end",
            oppositeAccountNumber:
                "Please enter the main account ID of the opposite terminal"
        },
        tooltip: {
            region:
                "Intranet resources of different regions are not interconnected and cannot be modified upon creation",
            name: "Refer to the peering connection name",
            accountType:
                "The same account: Refer to create peer-to-peer connection under the same account. Cross-account: Refer to create peer-to-peer connection under different accounts.",
            oppositeAccountNumber:
                "The account of opposite end refers to the main account ID under Account Management-Account and Permission",
            bandWidth:
                "For the users purchasing Elastic IP of fixed bandwidth type,which is applicable to the business scenario with stable network situation."
        },
        speechCraft: {
            sureDelete: {
                isSameRegion:
                    "Confirm to delete the peering connection: {0}? Upon deletion, the routing containing the peering connection in the Route Table will be deleted as well. ",
                isDiffRegionSameTenant:
                    "Confirm to delete the peering connection: {0}? Upon deletion, the routing containing the peering connection in the Route Table will be deleted as well and the peering connection will be no longer charged.",
                isDiffRegionDiffTenant:
                    "Confirm to delete the peering connection: {0}? Upon deletion, the routing containing the peering connection in the Route Table will be deleted as well and the peering connection at the initiator will be no longer charged."
            },
            sureAccept:
                "Confirm to accept the peering connection: {0}? Upon acceptance, the routing of VPCs will automatically distribute the configuration and mutual access is allowed among VPCs. ",
            sureReject: "Confirm to refuse the peering connection: {0}? ",
            acceptTitle: "Accept peer-to-peer connection",
            rejectTitle: "Refuse peer-to-peer connection",
            deleteTitle: "Delete peer-to-peer connection"
        },
        operations: {
            modify: {
                name: "Modify Bandwidth"
            },
            delete: {
                name: "Delete"
            },
            accept: {
                name: ""
            },
            reject: {
                name: ""
            }
        }
    },
    // 私有网络
    privateNetwork: {
        osNotPass: " ",
        regionOne: "cn-north-1",
        regionTwo: "cn-east-1",
        privateNetwork: "VPC",
        create: "Create",
        createTitle: "Create VPC",
        region: "Region",
        regionTip: "Create VPC",
        createTip:
            "The VPC of different geographical resources is not interworking by default and cannot be modified after creation",
        notChange: "Cannot be modified after creation",
        cidrTip:
            "The user can only configure the intranet segment when creating the first Cloud Physical Server in the same availability zone, and the intranet segment cannot be modified upon being created. The Cloud Physical Server purchased subsequently shall use the intranet segment by default. In case all Cloud Physical Servers of the user under the availability zone are recycled, the intranet segment can be configured again when purchasing the first Cloud Physical Server for another turn. It is suggested that the user shall well make the network plan before creating the Cloud Physical Server.",
        name: "Name",
        nameHelp:
            "1-32 characters, only supports Chinese, numbers, capital and lowercase letters, English underline “_” and line-through “-”.",
        segment: "IPv4 CIDR",
        ipv6Cidr: "IPv6 CIDR",
        ipv6CidrHelp:
            "For subsequently enabling the IPv6 public network access service, the system automatically creates an IPv6 Internet gateway",
        open: "Enabled",
        close: "Disabled",
        openIpv6: "Enable IPv6 ",
        description: "Description",
        descriptionHelp: "The length cannot exceed 256 characters.",
        sure: "Sure",
        cancel: "Cancel",
        delete: "Delete",
        delTitle: "Delete VPC",
        delConfirm: "Confirm to delete the VPC: {0}?",
        privateHelpDoc: "Help Documentation of VPC",
        operate: "Operations",
        deleteTip:
            "The VPC cannot be deteled.Please delete the Subnets of the VPC first",
        deleteForPeering:
            "This VPC cannot be deleted. Please disassociate it first.",
        deleteWithIpv6CidrTip: "",
        sourceInfo: "Resource Information",
        subnet: "subnet",
        baseInfo: "Basic Information",
        configInfo: "Configuration Information",
        id: "ID",
        copySuccess: "Copied",
        copy: "Copy",
        editName: "Modify Name",
        editDescription: "Modify Description",
        nameNotNull: "The name cannot be blank",
        nameNotPass: " ",
        desNotPass: " ",
        passwordNotNull: "The password cannot be blank",
        passwordNotPass: "请输入合规密码",
        repasswordNotNull: "Confirm that the password cannot be blank",
        repasswordNotPass:
            "Confirmation password is inconsistent with password",
        selectOs: "Please select Version",
        tableTitle: {
            name: "Name",
            cidr: "IPv4 CIDR",
            ipv6Cidr: "IPv6 CIDR",
            subNet: "Subnet",
            createTime: "Creation Time",
            operate: "Actions",
            ratio: "Available IPs/Total IPs"
        },
        searchTip: "Please enter the name for searching",
        area: "Availability Zone",
        createTime: "Creation Time",
        onlyOnePrivateNet: "Only one VPC can be created in the same region",
        delPrivateNetworkTip:
            "the associated IPv6 Internet gateway will be automatically deleted once VPC is deleted, and VPC IPv6 CIDR will be recycled and cannot be retrieved. Please operate carefully!",
        openPrivateNetworkIpv6Tip:
            "After it is enabled, the system will automatically create an IPv6 network segment and a free IPv6 Internet gateway for you ",
        openPrivateNetworkIpv6Confirm:
            "Confirm to enable the IPv6 function of Virtual Private Cloud: {0}? ",
        vpcCidr: "VPC IPv4 CIDR",
        vpcIpv6Cidr: "VPC IPv6 CIDR",
        noSuitableKey: "If no proper key is available",
        defaultGameVpcTip: "如需删除请提交工单(提供工单url:https://jrgd.jdcloud.com/applyorder/from?lobId=002s00080001)",
    },
    // 私有网络实例列表
    privateNetInstance: {
        emptyKeyPair: 'SelectKey is required',
        initKeyPair: "Initial Key",
        loginKeyPair: "Login key pair",
        SOSKeyPair: "SOS key pair",
        outConsole: "Out-of-band console",
        sosTip: "Obtain access mode of SOS out-of-band console",
        fixSOSTip:
            "By fixing SOS, when SSH key pair is selected, it will be automatically associated with the corresponding instance, and the access mode of SOS out-of-band console can be obtained.",
        sosKeyTip: "Key pair to access the SOS out-of-band console",
        initPairTip:
            "This key refers to the initial key at the time of system creation or re-installation.",
        keyPairTip:
            "Currently, association of key pairs is supported only when the system of Cloud Physical Server is reinstalled.",
        bindSure: "OK",
        auto: "Auto-assign",
        handwrite: "Customized",
        autoIPv4: "Auto-assign IPv4",
        handwriteIPv4: "Customized IPv4",
        operateSuccess: "Operate successfully",
        operateFail: "Operate failed",
        changeNet: "Change network",
        ipTip:
            "Intranets are all open,  Port 22 of public network is opened (remote SSH login)",
        currentNetworkMessage: "Current internet access information ",
        targetNetworkMessage: "Target network information",
        notIpTip: "Intranets are all open",
        notVPC: "--No available VPC--",
        notSubnet: "--No available subnet--",
        chooseVPC: "Please Select VPC",
        chooseTargetVPC: "Please select a target VPC",
        chooseSubnet: "Please Select Subnet",
        chooseTargetSubnet: "Please select a target Subnet",
        operations: {
            rePassword: "Reset Password",
            reOperateSystem: "Reinstall System",
            reVpcnetWork: "Replace VPC",
            reSubnetwork: "Replace subnet",
            reIntranetIp: "Replace private IP",
            ipv6: "Enable IPv6",
            onlyOneIpv6: "Maximum one IPv6 address is supported for instance",
            repay: "Renew",
            makeMirror: "Make image",
            bind: "Associate the EIP",
            unbind: "Disassociate the EIP",
            sos: "SOS",
            fixSOS: "Fix SOS",
            resetSOS: "Reset SOS",
            notWindows: "Only support in Linux OS",
            onlyNotError: "Only support in shutdown/running status",
            onlyShutDown: "Only support in shutdown status",
            onlyRunning: "Only support in running status",
            alreadyHaveIPv6:
                "The network of any instance with an assigned IPv6 address cannot be replaced",
            alreadyHaveNatRules: "已关联 DNAT、 SNAT 规则的实例不允许修改网络配置，请先删除 SNAT/DNAT规则。",
            alreadyBindEip:
                "The network of an instance which is associated with EIP cannot be replaced. Please disassociate EIP at first",
            alreadyBindOtherIp:
                "The network of an instance which is associated with an alias IP cannot be replaced. Please disassociate the alias IP at first ",
            alreadyAddLb:
                "The network of an instance added to the backend server group of Load Balancer cannot be replaced. Please remove the instance from Load Balancer RS ",
            onlySubmit:
                "So sorry! Password resetting does not support on-line operation for now, You may open ticket or contact customer service:400-615-1212 (7*24)",
            overdueTip: "Expired, overdue, or stopped instances do not support this operation",
            wrongDeviceType: "Customized machines do not support make image",
        },
        types: {
            compute: "Compute Type",
            storage: "Storage Type",
            gpu: "GPU"
        },
        statueNames: {
            creating: "creating",
            starting: "Starting",
            running: "running",
            stopping: "Shutting Down",
            stopped: "Stopped",
            restarting: "Rebooting",
            error: "Error",
            upgrading: "Resizing",
            reinstalling: "Reinstalling System",
            destroying: "Destructing",
            inconfig: "Configuring",
            resetting_password: "Resetting password",
            making: "Making",
        },
        reinstallCheck: "I have known the above risks",
        haveSOS: "Obtain access mode of SOS out-of-band console",
        SOScontent:
            "Access the out-of-band console of the server by the following command in the terminal:",
        fixSOS: "Fix SOS out-of-band console",
        resetSOS: "Reset SOS out-of-band console",
        fornowSOS: "Current associate key pair:",
        fixSOSTips1:
            "The SOS out-of-band console function was officially put on line on July 1, 2021. For instances created before July 1, 2021, it is required to automatically reinstall or manually modify the SOS to access the out-of-band console. For details, see",
        fixSOSTips2:
            " When SSH key pair is selected, it will be automatically associated with the corresponding instance, and the access mode of SOS out-of-band console can be obtained. ",
        sshName: "Key pair name",
        hostname: "HostName",
        hostInfo: "Machine Information",
        chargeMethod: "Billing Method",
        soldOut: "Sold Out",
        manager: "Administrator",
        manageTip: "Optional, computer name within the operating system",
        formatDataDisk: "Format all data disks simultaneously",
        hostHint:
            'It contains 2-60 characters, with uppercase and lowercase letters, numbers and line-through "-" supported. However, "-" cannot be used successively and cannot be used at the beginning or the end',
        hostnameTip:
            "The host name is the computer name within the operating system of the Cloud Physical Server and it can be defined and set by the user. Upon the production of the Cloud Physical Server, you can view the name by logging into the Cloud Physical Server. Where several Cloud Physical Servers are purchased once, numbers in increasing order will be put after the set name of each Cloud Physical Server by default to indicate the Cloud Physical Servers",
        public: "(public IPv4)",
        private: "(private IPv4)",
        ipv6Address: "(private IPv6)",
        submit: "Open ticket",
        openTitle: "Startup Notification",
        closeTitle: "Shut Down Notification",
        restartTitle: "Reboot Notification",
        repasswordTip: "Password Resetting Notification",
        closeTip: "Confirm to shut down the Cloud Physical Server:{0}",
        openTip: "Confirm to start up the Cloud Physical Server:{0}",
        restartTip: "Confirm to reboot the Cloud Physical Server:{0}",
        reInstallTitle: "Reinstall System",
        reInstallTip1:
            "<strong>Instructions for system re-installation:</strong> </br>" +
            "1、System reinstallation is for the initialization/changing operating system of the system " +
            "disk.</br> 2、This operation will clear the system disk data of the Cloud Physical Server, so" +
            " please back up; JD cloud will take no liability for any data loss due to failure of" +
            " backup. </br>3、If you select to format the data disk, the data in the data disk will be " +
            "cleared at the same time. When the system is re-installed, the attached data disk needs to be " +
            "loaded again..</br>4、The installed monitoring plug-ins will be automatically uninstalled" +
            " after the system is reinstalled. Please reinstall the desired plug-ins for use.</br>5、If you choose not to format the data disk, the data disk needs to be mounted again after the system is reinstalled. If the mounting point and the system disk are the same, it means that the mounting failed. Please mount the data disk again. ",
        reInstallTip2:
            " 6、After system reinstallation, the system will not configure the IPv6 address for the instance by default, and thus you need to configure it manually .</br>",
        renetworkTip:
            "Note:</br>" +
            "1. The network configuration of an instance added to the backend sever group of Load Balance cannot be modified. If the modification is required, please remove the instance from the backend server group.</br>" +
            "2. The network configuration of an instance which is associated with alias IPs cannot be modified. If such modification is required, please disassociate all alias IPs of the instance at first (single internet access and double internet accesses); </br>" +
            "3. The network configuration of an instance to which an IPv6 is distributed cannot be modified。</br>" +
            "4. The network configuration of an instance associated with EIP cannot be modified. If the modification is required, please disassociate EIP at first</br>",
        batchRepassordTips:
            "Note: </br>" +
            "1. Passwords of instances, reset with the method, are the same</br>" +
            "2. After the password is reset, the new password can take effect only after the instance is started via the Console</br>",
        batchRenameTips:
            "Note: The names of instances edited through the method are the same",
        batchDeleteTips:
            "Note: </br>" +
            "1. All data will be cleared and become unrecoverable after the Cloud Physical Server is deleted. Please back up your data in advance; </br>" +
            "2. When the Cloud Physical Server is deleted, resources in the virtual server group of the Load Balancer will be deleted as well; but the associated elastic IP will be kept continuously. If you do not need to keep it, please go to the corresponding page to delete it, so as not to incur extra costs. </br>",
        changeNetworkTips:
            "If you select the wrong VPC or plan the network again when creating an instance, you can replace the VPC, subnet, or Intranet IP address of Cloud Physical Server.</br>" +
            "The network change function cannot be enabled in the following scenarios:</br>" +
            "①The network configuration of an instance added to the backend sever group of Load Balance cannot be modified. If the modification is required, please remove the instance from the backend server group.</br>" +
            "②The network configuration of an instance which is associated with alias IPs cannot be modified. If such modification is required, please disassociate all alias IPs of the instance at first (single internet access and double internet accesses).</br>" +
            "③The network configuration of an instance to which an IPv6 is distributed cannot be modified</br>" +
            "④The network configuration of an instance associated with EIP cannot be modified. If the modification is required, please disassociate EIP at first.",
        showDetails: " View details",
        putaway: " Fold",
        open: "Start Up",
        payNow: "Pay Now",
        shouldPay: "Amount Payable",
        clause: "Cloud Physical Server Terms",
        readAndAgree: "I have read and agreed to",
        firstStep: "The First Step",
        secondStep: "The Second Step",
        thirdStep: "The Third Step",
        orderConfirm: "Order Confirmation",
        payConfirm: "Payment Confirmation",
        payFinish: "Payment Completion",
        orderTip:
            "Cannot delete resources under monthly package berfore expiration time to ensure normal use",
        orderInfo: "Order Information",
        productType: "Product Type",
        spcDetail: "Configuration Detail",
        calculating: "Calculating...",
        constPayments: "By fixed bandwidth",
        standardMirror: "Standard Image",
        compute: "Compute",
        gpu: "GPU",
        configTip:
            "Please select different virtual Cloud Physical Server specification according to specific business, please refer to",
        autoShowTip: "Automatically Allocate within the Section {0}",
        byBandwidth: "BGP,{0}Mbps by bandwidth",
        configDetail: "Detailed Introduction",
        firewallTip: "Refer to the Operation Guide for firewall settings",
        cancel: "Cancel",
        sure: "Sure",
        unBindTitle: "Disassociate the EIP",
        sureUnBindTip: "Confirm to disassociate the EIP: {0}?",
        bindTitle: "Associate the EIP",
        chooseBindTip: "Please select EIP to be associated with {0}",
        tableTitle: {
            ip: "IP Address",
            bandWidth: "Bandwidth",
            region: "Availability Zone"
        },
        cps: "Cloud Physical Server",
        baseInfo: "Base Information",
        configInfo: "Configuration Information",
        networkInfo: "Network Information",
        sourceInfo: "Resource Information",
        hardWareMonitor: "Hardware Monitoring",
        running: "Running",
        helpDoc: "CPS Documentation",
        id: "ID",
        name: "Name",
        description: "Description",
        monthAndYear: "Monthly Package",
        discount: "Sale",
        regionAndArea: "Availability Zone",
        region: "Region",
        valArea: "Availability Zone",
        agent: {
            status: "Agent status",
            normal: "Normal",
            abnormal: "Abnormal",
            installWarn:
                "For agent installing and uninstalling, please refer to the {link}",
            guide: "Operation Guide",
            installWarn2: "Free installation of {link}",
            installWarnWindows:
                "Windows doesn't support performance monitoring",
            plugin: "monitoring plugin"
        },
        regionTip:
            "Resources in different regions cannot communicate through the private network .Cannot modify the region after creation",
        config: "Configuration",
        series: "Series",
        type: "Categories",
        mirror: "Image",
        mirrorType: "Image Type",
        operateSystem: "Operating System",
        systemVersion: "System Version",
        storage: "Storage",
        sysDisk: "System Disk",
        dataDisk: "Data Disk",
        sysDiskTip:
            "If the system disk comprises a hard disk, it is automatically configured with" +
            " NO RAID. If the system disk comprises two hard disks, it will be automatically configured" +
            " with RAID1.",
        network: "Network",
        createPrivateNetwork: "Create VPC",
        createSubNet: "Create Subnet",
        privateNet: "VPC",
        targetPrivateNet: "Target VPC",
        privateNetCidr: "IPv4 CIDR: {0}",
        privateNetIpv6Cidr: ",IPv6 CIDR: {0}",
        subnet: "Subnet",
        targetSubnet: "Target subnet ",
        intranetIp: "Private IP",
        targetIntranetIp: "Target subnet IP ",
        intranetIpTip: "IPv4 will be automatically assigned in {0} .",
        intranetIpv6Tip: "IPv6 will be automatically assigned in {0} .",
        internetIpTipTwo:
            "If Customized is selected,please specify IPv4 within{0}，Creation of Cloud Physical Server in batch is not available now",
        internetIpv6TipTwo:
            "If Customized is selected,please specify IPv6 within{0}，Creation of Cloud Physical Server in batch is not available now",
        internetIpTipTwo1: "Please customized IPv4 within {0} ",
        autoAllocationTip: '您选择“自动分配 IPv4”方式后，系统会随机分配一个 IPv4 地址为您更换网络，请谨慎操作。',
        firewall: "Firewall",
        bandwidth: "Bandwidth",
        internetIpWarning:
            "If you do not buy public IP, you will not be able to access Cloud Physical Server from public IP. It does not support to add public IP later.",
        internetIpTitle: "Note",
        read: "Read and Agree",
        tip: "tip",
        username: "User Name",
        password: "Password",
        repassword: "Confirm Password",
        instanceNameTip:
            "1-32 characters, only supports Chinese, numbers, capital and lowercase letters, English underline “_” and line-through “-”.",
        descriptionTip: "The length cannot exceed 256 characters.",
        passwordTip:
            '8-30 characters, and simultaneously including three types (Capital letters, lowercase letters, numbers or special characters ()`~!@#$%&*_-+=|{}[]:";\'<>,.?/)',
        count: "Quantity",
        selectedConfig: "Selected Configuration",
        buyNow: "Buy Now",
        spec: "Specifications",
        interNetwork: "Internal IP",
        publicNetIp: "Public IP",
        duration: "Duration",
        charge: "Cost",
        create: "Create",
        instanceID: "Instance ID",
        instanceName: "Instance Name",
        shutdown: "Stopped",
        restart: "Reboot",
        error: "Error",
        clickCommit: "Click to open ticket",
        more: "More",
        chargeType: "Billing Type",
        createTime: "Creation Time",
        expireTime: "Expiration Time",
        networkType: "Network Type",
        netBelongs: "VPC",
        publicNetBandwidth: "Public Network Bandwidth",
        fireWall: "Firewall",
        defaultFireWall: "Default Linux Open Port 22",
        operateGuid: "Operation Guide",
        onlyShutDown: "Only support in shutdown status",
        onlyRunning: "Only support in running status",
        operate: "Operations",
        listTitle: {
            name: "ID/Instance Name",
            monitor: "Monitor",
            region: "Availability Zone",
            ipAddress: "IP Address",
            privateAndSub: "VPC/Subnet",
            netType: "Network Type",
            status: "Status",
            spc: "Specifications",
            config: "Configuration",
            charge: "Billing Type",
            operate: "Actions",
            createTime: "Creation Time",
            cidr: "CIDR",
            subnet: "Subnet",
            onlyName: "Name"
        },
        configListTitle: {
            spcType: "Specifications",
            spc: "Type",
            cpu: "CPU",
            memory: "Memory",
            netCard: "Network Interface",
            GPU: "gpu"
        },
        placeholderId: "Please enter ID to search",
        placeholderName: "Please enter the name for searching",
        yearLabel: "year",
        oneYear: "one year",
        twoYear: "two years",
        threeYear: "three years",
        oneYearCountLabel: "17% off for One-year Cloud Physical Server service",
        twoYearCountLabel: "17% off for Two-year Cloud Physical Server service",
        threeYearCountLabel:
            "17% off for Three-year Cloud Physical Server service",
        buyTime: "Duration",
        counts: "Quantity",
        autoIpTip: "IP address will be assigned automatically",
        notAutoIpTip: " Please enter the IPv4 address",
        notAutoIpv6Tip: " Please enter the IPv6 address",
        buyCountTip:
            "The maximum purchase quantity of a single order is 1; if expansion is needed, please contact customer service or {0}",
        arrear: "In Arrears",
        subnetBelongTo: "Subnet",
        subnetIpv6Cidr: "Subnet IPv6 CIDR",
        enableIpv6Tip:
            "Allocation of maximum 1 IPv6 address is supported for the current network interface",
        isEnableIPv6: "Enable IPv6 public network or not?",
        hasEnabledIPv6: "Enabled",
        hasDisabledIPv6: "Disabled",
        enablePublicNet: "Go to enable public network",
        sosSecretKeyTipPart1:
            "1. This key is used to access the SOS out-of-band console.</br>",
        sosSecretKeyTipPart2:
            "2. The user must manually modify the password to access the SOS out-of-band console.</br>",
        turnOnDeleteProtectTip:
            "Confirm to enable instance deletion protection for instance {0}?",
        turnOffDeleteProtectTip: "确认将实例{0}关闭实例删除保护？",
        deleteProtect: "Instance deletion protection",
        deleteProtectOn: "Enabled",
        deleteProtectOff: "Closed",
        instanceInfo: "Instance information",
        instanceConfig: "Instance configuration",
        mirrorInfo: "Image information",
        // gpuMonitoring: { // GUP监控相关文案 TODO
        //     gpuMemoryTotal: "Gpu Memory Total",
        //     gpuUtilization: "Gpu Utilization",
        //     gpuMemoryUsed: "Gpu Memory Used",
        //     gpuMemoryUtilization: "Gpu Memory Utilization"
        // },
    },
    // 镜像
    mirror: {
        text: {
            title: "Image",
            mirrorIdAndName: "ID/Image Name",
            allStatus: "All",
            availableStatus: "Available",
            errorStatus: "Error",
            mirrorType: "Image Type",
            architecture: "Architecture",
            osType: "Operation System",
            systemVersion: "OS version",
            createTime: "Creation Time",
            mirrorId: "Image ID",
            mirrorName: "Image Name",
            doc: "Image Documentation",
            createInstance: "Create",
            commonMirror: "Public/Customized Image",
            publicMirror: "Public Image",
            customizeMirror: "Customized Image",
            privateMirror: "Private Image",
            importMirror: "Import Image"
        },
        tips: {
            search: {
                mirrorId: "Please enter the ID for precise search",
                mirrorName: "Please enter the Name for fuzzy search",
            },
            createdInstanceDeleteNotAllowed: "Are you sure to delete the image? The  image information is as follows:",
            deleteMirror: "Are you sure to delete the image? The  image information is as follows:",
        },
        operations: {
            delete: {
                name: "Delete"
            },
            create: {
                name: "Create"
            }
        }
    },
    // 重置密码
    passwordReset: {
        sentence:
            "Please note: After being reset, the password of the Cloud Physical Server can" +
            " come into force only when the Cloud Physical Server is rebooted in the Console.",
        newPassword: "New Password: "
    },
    // 负载均衡
    slb: {
        operations: {
            edit: { name: "Edit" },
            open: { name: "Enable" },
            close: { name: "Disable" },
            delete: { name: "Delete" }
        },
        text: {
            allAz: "All AZs",
            unbindPublicIp: "Disassociate Public IP",
            renew: "Renew",
            id: "ID",
            publicNetBandwidth: "Public Network Bandwidth",
            delete: "Delete",
            slb: "Load Balancer",
            slbId: "Instance ID",
            slbName: "Instance Name",
            listener: "Listener",
            createListener: "Create a listener",
            name: "Name",
            protocolPort: "Listening Protocol: Port",
            opened: "Enable",
            running: "Running",
            closed: "Disable",
            algorithm: "Scheduling Algorithm",
            roundRobin: "Weighted Round Robin",
            leastConnections: "Weighting Least Connection Count",
            ipHash: "IP Hash",
            conhash: "Source IP",
            stickySession: "Session Persistence",
            stickySessionTimeout: "Session Persistence Time-out ",
            sessionType: "Session Type",
            setCookie: "Implant Cookie",
            rewriteCookie: "Rewrite Cookie",
            httpHeader: "Obtain HTTP header fields ",
            domain: "Domain",
            certificate: "Certificate",
            healthCheck: "Health Check",
            defaultServerGroup: "Default Server Group",
            stopped: "Inactive",
            active: "Active",
            edit: "Edit",
            slbHelpDoc: "Help Documentation of Load Balancer",
            protocol: "Listening Protocol",
            port: "Port",
            http2: "HTTP 2.0",
            realIp: "Get actual IP",
            createCertificate: "Create Certificate ",
            healthCheckTimeout: "Response Time-out Period",
            healthCheckInterval: "Health Check Interval",
            healthCheckThreshold: "Healthy Threshold",
            times: "{0}Time(s)",
            unhealthyCheckThreshold: "Unhealthy Threshold",
            healthCheckUri: "Check Path",
            healthCheckHttpCode: "Normal Status Code ",
            serverGroup: "Server Group",
            relatedServerGroup: "Associate with backend server group",
            healthCheckIp: "Health Check IP",
            openListener: "Enable listener",
            closeListener: "Disable listener",
            deleteListener: "Delete listener",
            bandwidth: "Bandwidth Cap",
            publicNet: "Public Network",
            ipv4: "IPv4",
            cps: "Cloud Physical Server",
            netType: "Network Type",
            ipVersion: "IP Version",
            privateNetwork: "VPC",
            bindServerType: "Server type",
            baseInfo: "Base Information",
            instanceName: "Instance Name",
            description: "Description",
            publicIp: "Public IP",
            bandwidthCalModel: "Charge Mode",
            lineType: "IP Provider",
            maxBandWidth: "Bandwidth",
            constBandWidth: "By fixed bandwidth",
            bgp: "BGP",
            buyEip: "Purchase the Elastic IP",
            detail: "Detailed Introduction >>",
            publicIpInfo: "Bandwidth of {0} is {1}Mbps",
            createPrivateNet: "Create VPC",
            baseConfig: "Basic Configuration",
            protocolAndPort: "Listening Protocol and Port",
            backendServer: "Backend Server",
            chooseBackendServer: "Select backend server",
            chooseBackendGroup: "Select server group",
            addServer: "Add server",
            addServerGroup: "Add server group",
            openSlb: "Enable Load Balancer",
            network: "Network",
            sourceFee: "Resource Cost ",
            configFee: "Cost",
            closeSlb: "Disable Load Balancer",
            listenerNumber: "Listener Count",
            addListener: "Add listening",
            bindPublicIp: "Associate with Public IP",
            healthyStatus: "Health Status",
            backendServerGroups: "Backend Server Group",
            editListener: "Edit listener",
            timeCount: "Times",
            associatedMonitor: "Associate Listening",
            cert: "Certificate",
            certContent: "Certificate Content",
            monitorProtocol: "Listening Protocol: Port",
            associatedMonitoring: "Associate Listener",
            createCert: "Create Certificate",
            addCert: "Add Certificate",
            deleteCert: "Delete Certificate",
            subKey: "Private Key",
            example: "Sample Reference",
            sni: "SNI management",
            addDomain: "SNI management",
            editDomain: "Edit extension domain name",
            accessControl: "Access control",
            manageStrategy: "Management strategy",
            ruleType: "Rule type",
            priority: "Priority",
            ipAddressOrCidr: "IP address/address field",
            blackList: "Blacklist",
            whiteList: "Whitelist",
            addOneAcl: "Add a policy",
            customSetting: "Personalization",
            codeAllocation: "Code configuration"
        },
        sentence: {
            inputDomain: "Please enter domain name",
            chooseCertificate: "Please select the certificate",
            deleteVirtualServerGroupTip:
                "Confirm to delete the virtual server group: {0}? After the group is deleted, all resources in the group will be deleted at the same time. ",
            weightTip: " ", // 保留一个空格
            fullTip:
                "The resource quota of the region is used up, please switch the region or open ticket to increase quota.",
            publicIpTip:
                "It does not support to purchase Public EIP temporarily, which can be purchased separately and associated after the Load Balancer is created.",
            instanceNameTip:
                "1-32 characters, only supports Chinese, numbers, capital and lowercase letters, English underline “_” and line-through “-”.",
            descriptionTip:
                "Description: The length cannot exceed 256 characters.",
            soldOut:
                "The quota of resources of the selected region is full, please switch the region or",
            openTicket: " open ticket",
            increaseLimit: " increase quota",
            fireWallDefault: "Default Linux Open Port 22",
            open: "Confirm to enable the listener:{0}?",
            close: "Confirm to disable the listener:{0}?",
            delete: "Confirm to delete the listener:{0}?",
            sureDeleteCert: "Confirm to delete the certificate: {0}?",
            deleteWarning:
                "To delete the certificate, please delete the associated listening first",
            cannotDelete:
                "Certificate deletion failed. Please delete the associated listening first ",
            deleteInfo:
                "After the listener is deleted, corresponding backend server will be disassociated with the listener.",
            protocolAndPort:
                "After listening rules are created, listening protocols and ports cannot be modified.Ports externally provided by Load Balancer are" +
                " generally 80 for TCP/HTTP, 443 for HTTPS.",
            roundRobin:
                "Via weighted round robin, access requests will be distributed to the backend server in turn. The greater the weight value of backend server is, the greater the times (probability) of round robin is.",
            leastConnections:
                "Except that round robin is made to each backend server based on the weight value setting, actual load (i.e. connection count) of such backend server shall be considered as well. Where the weight value is the same, the less the current connection number, the greater the times (probability) of backend server subject to round robin.",
            ipHash:
                "Each request is hashed according to the Ribbon IP, and requests from the same client will be distributed to the same backend server.",
            conhash:
                "Consistent hash based on the same source IP address will be scheduled to the" +
                " same backend server.",
            stickySession:
                "Once session persistence is enabled, requests from the same client will be always forwarded to the same server.",
            stickySessionTimeout: "Duration Setting Range: 30-3600 ",
            realIp:
                "Before enabling the function, the user must make relevant configuration on the backend server. Otherwise, normal work cannot be conducted. For details, see",
            healthCheckTimeout:
                "2~60s, the response time-out period must be less than the health check interval.",
            healthCheckTimeoutPart1: "2~60s",
            healthCheckTimeoutPart2:
                "the response time-out period must be less than the health check interval.",
            healthCheckInterval: "Range 5~300",
            healthCheckIntervalPart1: "Range 5~300",
            healthCheckIntervalPart2:
                "the response time-out period must be less than the health check interval.",
            healthCheckThreshold: "Range 1~10",
            healthyThreshold: "Range 1~10",
            unhealthyThreshold: "Range 1~10",
            port: "Range:1-65535",
            portPart1: "Range:1-65535",
            portPart2:
                "Listening ports under the same Load Balancer instance cannot be repeated",
            openSlb: "Confirm to enable the Load Balancer:{0}?",
            closeSlb: "Confirm to disable the Load Balancer:{0}?",
            overQuota:
                "The quota of resources of the selected region is full, please switch the region or",
            eipExceedQuota: "Eip exceeding purchase quota!",
            contact:
                " Please contact customer service 400-615-1212 (7*24) for consulting, or",
            overEipQuota:
                "EIP resource quota of the selected region is used up, please switch the region or",
            ipSearch: "Please enter an IP address for search",
            idSearch: "Please enter instance ID for search",
            nameSearch: "Please enter instance name for search",
            bindEipNecessary:
                "It can be enabled only after an EIP is associated",
            moreThan50:
                "Support creation of 50 listeners only under the same Load Balancer instance",
            moreThan100:
                "Support creation of 100 certificates only under the same region",
            deleteSlbTip:
                "Notes: </br>" +
                "1. All associated listeners and virtual server groups will all be deleted and unrecoverable once the Load Balancer is deleted;</br>" +
                "2. After the Load Balancer is deleted, the backend Cloud Physical Server will be kept continuously. If you do not need to keep it, please go to the corresponding page to delete it, so as not to incur extra costs.",
            sureCharge:
                "I am clear about the cost, and agree to delete the associated listeners and virtual server groups on my own",
            deleteSlbChecnkWarning: "Confirm to delete the Load Balancer:{0}?",
            deleteDomainTip: "Are you sure to delete the extended domain name?",
            forbiddenEmportyDomain: "The domain name cannot be blank.",
            domainNotStandardTip: "Please enter a legal domain name",
            domainRepeatTip:
                "At most one certificate can be selected for the same domain name",
            domainTotalTip:
                "Twenty extension domain names can be configurable for one listener",
            customSettingTip:
                "A listener can be configured with a personalized configuration item",
            aclIpTip: "Please enter a single IP address/address field",
            deleteStrategyTip:
                "Are you sure to delete this policy? After deletion, it will be disassociated with this listener. Please operate with caution!",
            closeCustomSetting:
                "Are you sure to disable personalization? The directives configuration will be initialized after disabling.",
            ruleTypeTip: "Please select types of rule",
            forbiddenEmportyIp: "Do not leave IP address/address segment blank",
            legalIpRequire: "Please enter a valid IP address/address segment"
        },
        tooltip: {
            priorityTip:
                "Match in sequence (starting with the rule with the smallest number. The smaller the number, the higher the priority).",
            regionTip:
                "Resources in different regions cannot communicate through the private network .Cannot modify the region after creation.",
            calModel:
                "For the users purchasing EIP of fixed bandwidth type, billing by bandwidth upper limit will be designed according to their selected public network with the unit of Mbps, which suits the business scene with more stable network situation.",
            bgp: "BGP network can provide higher access speed.",
            boundSlb: "Current load balancer has associated EIP",
            certNull: "The certificate content cannot be blank",
            privateKeyNull: "The private key cannot be blank",
            stickySessionTimeout:
                "If there is no new request in the connection within the session persistence period, session persistence will be interrupted automatically",
            httpHeaderForTip:
                "Obtain the actual IP address of a client through X-Forwarded-For field",
            httpHeaderForProto:
                "Obtain the listening protocol of Load Balancer through X-Forwarded-Proto field ",
            httpHeaderForPort:
                "Obtain the listening port of Load Balancer through X-Forwarded-Port field",
            httpHeaderForLbip:
                "Obtain the EIP of Load Balancer through X-Forwarded-LBIP field",
            healthCheckTimeout:
                "Maximum period for each health check response.",
            healthCheckInterval: "Health check time interval.",
            healthyThreshold:
                "Refer to the connection health count of backend instance from failed to successful.",
            unhealthyThreshold:
                "Refer to the connection health failure count of backend instance from successful to failure.",
            healthCheckUri:
                'Target path of health check must be started with "/" and only specific file path can be entered. The root directory is the default directory, and only numbers, letters (uppercase and lowercase), ".", “%”, "?” , “#”, “&” and “=”, with at most 100 characters.',
            healthCheckHttpCode:
                "Please use HTTP status code when checking successful response from backend instances. You can enter 2xx (equivalent to 200-299), 3xx (equivalent to 300-399) and 4xx (equivalent to 400-499), with values separated with “,”. Restriction: Now, normal state codes of 2xx, 3xx and 4xx can be entered now.",
            countLimit:
                "Only 50 virtual servers can be created under the same Load Balancer instance",
            netTypeTip:
                "Provide the Load Balancer Service to be accessed via public network."
        },
        serverGroup: {
            slbVpcName: "VPC for Load Balancer",
            instanceVpcName: "VPC for Instance Interface",
            nameDuplicate: "The name already exists",
            numberLimit: "Support addition of 100 servers only",
            serverGroupName: "Virtual Service Group Name",
            sourceCount: "Resource Count",
            deleteVirtualServerGroup: "Delete virtual server group",
            addVirtualServerGroup: "Add virtual server group",
            editVirtualServerGroup: "Edit virtual server group",
            virtualServerGroup: "Virtual Server Group",
            virtualServerGroupDetail: "Details of Virtual Server Group",
            weightRange: "Integer from 1-100",
            portRange: "Integer from 1-65535",
            portRangePlaceHolder: "1-65535",
            weightRangePlaceHolder: "1-100",
            portNumberTip: "Port number must be unique",
            defaultServerGroup: "Default Server Group",
            sourceType: "Resource Type",
            instanceName: "Instance Name",
            instanceId: "Instance ID",
            region: "Availability Zone",
            ipAddress: "Target Private IP Address",
            port: "Port",
            weights: "Weight",
            status: "Status",
            operate: "Operations",
            editWeight: "Edit weight",
            remove: "Remove",
            add: "Add",
            cps: "Cloud Physical Server",
            cancel: "Cancel",
            sure: "Sure",
            editTip:
                "The greater the weight is, the higher the probability of forwarding server to request is",
            cpsName: "Name of Cloud Physical Server",
            addServer: "Add backend server",
            optionalServer: "Optional Instance",
            chosenServer: "Selected Instance",
            addServerTip:
                "Addition of maximum 100 servers is supported and one port of the same Cloud Physical Server is one server",
            delete: "Delete",
            removeTip: "Confirm to remove the instance {0}"
        }
    },
    // 路由表
    rib: {
        rib: "Route Table",
        helpDoc: "Help Documentation of Route Table",
        configInfo: "Configuration Information",
        type: "Type",
        privateNetwork: "VPC",
        id: "ID",
        name: "Name",
        createTime: "Creation Time",
        region: "Availability Zone",
        sourceInfo: "Resource Information",
        baseInfo: "Base Information",
        copySuccess: "Copied",
        routeStrategy: "Route Policies",
        defaultRib: "Default Route Table",
        defaultRoute: "Default Route",
        tableTitle: {
            name: "Name",
            privateNetwork: "VPC",
            type: "Type",
            createTime: "Creation Time",
            destination: "Target End",
            nextHopType: "Type of Next Hop",
            nextHop: "Next Hop"
        }
    },
    // ssh
    ssh: {
        text: {
            ssh: "SSH Key Pair",
            name: "Key Pair Name",
            createTime: "Creation Time",
            createType: "Creation Method",
            create: "Create a new key pair",
            newParis: "Create a new key pair",
            existingPublicKeys: "Use existing public keys",
            enterPublicKey: "Enter public key",
            publicKeyFingerPrint: "Public Key Fingerprint"
        },
        help: {
            doc: "Help Documentation of SSH Key Pair",
            nameRule:
                "It cannot be null, and only numbers, letters (uppercase and lowercase), English underline “_” and line-through “-” are allowed, with at most 32 characters",
            createTip:
                "After creation is completed, please confirm the private key is successfully downloaded to the local. To guarantee Cloud Physical Server security, the private key can be downloaded once only and please properly keep it.",
            publicKeyPlaceholder: "Public key format: ssh-rsa AAAAB3NzaC1yc2…",
            nameSame: "Names cannot be repeated",
            publicKeyNotValid: "The format is incorrect. Please re-enter",
            publicKeyNull: "The public key cannot be null",
            deleteNotAllowed:
                "It is not allowed to delete the key of the instance which is creating or reinstalling",
            deleteKey: "Delete Key Pair",
            deleteKeyTip:
                "After the key pair is deleted, you can still use the private key saved locally to log in to the Cloud Physical Server associated with the key pair.However, the SOS out-of-band console cannot be accessed through the original key pair. If access is required, please reset the SOS.",
            confirmToDelete: "Confirm to delete {0}?",
            quotaFullUsed:
                " The resource quota of the selected region is used up, please switch the region or",
            increaseQuota: "increase quota",
            successAlert:
                "Private key will be automatically downloaded to your local disk. Please be sure to keep it properly and do not disseminate it on the Internet. JD Cloud will not keep your private key."
        },
        operations: {
            delete: {
                name: "Delete",
                tip:
                    "The instance status is creating or reinstalling, and the key pair cannot be deleted"
            }
        }
    },
    // ipv6
    ipv6: {
        text: {
            ipv6: "IPv6-Internet-Access",
            idOrGatewayName: "ID/Gateway Name",
            privateNetwork: "VPC",
            createTime: "Creation Time",
            manageIpv6Address: "Manage IPv6 address",
            gatewayId: "Gateway ID",
            gatewayName: "Gateway Name",
            region: "Region",
            ipv6Eip: "IPv6 Public Network Bandwidth",
            ipv6Address: "IPv6 address",
            ipv6AddressId: "IPv6 address ID",
            ipv6Id: "IPv6 ID",
            openPublicnetwork: "Enable public network",
            bandwidthLimit: "Bandwidth Cap",
            az: "Availability Zone",
            openIpv6PublicNetwork: "Enable IPv6 public network",
            deleteIpv6PublicNetwork: "Delete public network access",
            choosedCount: "Selected",
            enableipv6CountTip:
                "aximum 10 IPv6 addresses can be added in one operation.",
            bandwidthCalMode:
                "The purchased fixed IPv6 bandwidth is applicable to business scenarios with stable network.",
            buyNum: "Quantity",
            rip: "Private IP",
            aliasip: "IP alias"
        },
        speechCraft: {
            deleteIpv6CheckWarning:
                "Confirm to delete the public network bandwidth of IPv6 address {0}?",
            afterDeleteIpv6Tip:
                "After deletion, the public network bandwidth of the IPv6 address will become 0Mbps and the IPv6 address will only have the private network communication permission.",
            openPublicnetworkTip1:
                "As the current account is not tagged, resources charged by configuration cannot be created，Please",
            openPublicnetworkTip2: "open ticket",
            openPublicnetworkTip3:
                "for applying for tagging and then enabling IPv6 public network"
        },
        placeholder: {
            search: {
                gatewayId: "Please enter gateway ID to search ",
                gatewayName: "Please enter gateway name to search",
                ipv6Address: "Please enter IPv6 address to search",
                idSearch: "Please enter instance ID for search",
                nameSearch: "Please enter instance name for search",
                ipv6Id: "Please enter IPv6 ID to search ",
                ipAddress: "Please enter IPv6 address to search",
                enableIpv6Address:
                    "Please select the IPv6 address to register for the public network service"
            }
        },
        operations: {
            manage: {
                name: "Manage IPv6 address",
                tip: ""
            }
        },
        help: {
            doc: "IPv6 Internet Access Help Documentation"
        }
    },
    // 自定义脚本
    customScript: {
        hasBase64:
            "If base64 encoding is made to the existing contents entered, please check 'the base64 encoding is made to the following entered contents'.",
        noBase64:
            "If base64 encoding is not made to the existing contents entered, please uncheck 'the base64 encoding is made to the following entered contents'.",
        firstLine:
            "The format is incorrect. Before encoding, please respectively use #!/bin/bash and #!/usr/bin/env python as the first line of the contents.",
        windowsFirstLine:
            "The format is incorrect. Before encoding, be sure to start with “rem cmd” in the first line, and set <powershell></powershell> in the first and last lines.",
        originMax: "Data before encoding shall not be greater than 16KB.",
        encodeMax: "Data before encoding shall not be greater than 16KB."
    },
    game:{
        title: "游戏服务器",
        helpDoc: '游戏服务器帮助文档',
        list: {
            tutorial: "游戏教程",
            create: "创建游戏",
            windows: "Windows连接",
            windowsConnect: "Windows电脑连接游戏服务器",
            windowsConnectContent: {
                "method1": "方法1",
                "method2": "方法2",
                "method2Field": "如果方法1遇到问题，可以手动连接，具体如下：",
            },
            macConnect: "Mac电脑连接游戏服务器",
            macConnectContent: {
                "tips": "前提：Mac电脑安装好Windows远程桌面软件(比如 Microsoft Remote Desktop)"
            },
            playBtnText: "视频演示专区",
            mac: "MAC连接",
            other: "其他兼容性",
            otherConnect: "其他兼容性连接",
            connnectSetting: "（仅为连接设置）",
            gameGuide: "畅玩游戏攻略>>",
            steamGuide: "畅玩攻略设置（Steam）",
            deskGuide: "畅玩攻略设置（ToDesk)",
            practices: "最佳实践",
            recommendation: "推荐游戏",
            rapidDeployment:"快速部署",
            wukong: "黑神话悟空",
            questions: "常见问题",
            question: {
                'modifyBw': "购买游戏服务器后，如何修改带宽",
                "modifyCon": "如何升降配游戏服务器的配置 ",
                "connectServer": "如何一键连接游戏服务器",
                "renewal": "如何续费游戏服务器",
            },
            closeRedTip: "注意：实例关机后，仍然会产生计费。",
            closeTip: "确认关闭游戏服务器：{0}?",
            openTip: "确认开启游戏服务器：{0}?",
            restartTip: "确认重启游戏服务器：{0}?",
            deleteTip: '<span class="label">确认删除游戏服务器：</span>{0}?',
            sureCharge: "我已清楚费用问题，我同意自行删除关联的所有资源(含弹性公网IP)",
            linkType: "连接方式",
            oneClickConnection: "一键连接",
            oneClickDoc: "一键下载文件",
            oneClickConnectionTip: '请先"一键下载文件"',
            steamGuideTitle: "Steam畅玩模式（免费且只需要20Mbps带宽）",
            steamGuideTips: {
                setSteam: "1、设置Steam",
                streamGames: "2、串流玩游戏",
                exceptionHandling: "3、异常处理"
            },
            deskGuideTitle: "ToDesk畅玩模式（需要购买ToDesk游戏版并开启40Mbps带宽）",
            deskGuideTips: {
                setSteam: "1、设置ToDesk",
                streamGames: "2、ToDesk玩游戏",
                exceptionHandling: "3、ToDesk玩游戏高级设置"
            },
            specificationType: {
                gpu: "{0}，{1}GB显存",
                cpu: "{0} {1}核",
                memory: "{0} {1}GB",
                sysDisk: "{0}GB {1}",
                bw:"{0}Mbps"
            },
            gameServerGuide: "一键连接游戏服务器引导",
            modifyBandwidth: {
                tip: '若要调整公网带宽大小，可前往弹性公网IP列表页-点击修改带宽操作即可。'
            },
            resetPasswordTip: "重置实例密码后，只有在控制台对实例进行开机才能生效。"

        },
        create: {
            buyInstance: "创建游戏服务器",
            game: "游戏",
            configuration: "配置",
            tips: {
                wukong: "注：您需自行到Steam购买游戏，通过快速部署即可畅玩。",
                payByHour: "按实际使用时长以小时为单位结算。",
                payByDay: "预付费模式，按月购买及续费，相较按配置具有较大优惠。"
            },
            payByHour: "按小时",
            payByDay: "按月",
            gpu: "GPU",
            cpu: "CPU",
            memory: "内存",
            sysDisk: "系统盘",
            eip: "公网带宽",
            feePerHour: '¥{0}/每小时',
            feePerDay: '¥{0}',
            feePer: '¥{0} ',
            oneHour: ' 每小时',
            oneDay: ' 每月',
            gpu: 'GPU',
            cpu: 'CPU',
            memory: '内存',
            sysDisk: '系统盘',
            soldOut: '已售罄',
            videoMemory: '显存',
            feeDetail: '费用明细',
            configFee: '配置费用',
            configDetail: '配置明细',
            feeItem: '计费项',
            originPrice: "原价",
            discount: '折扣',
            cost: "费用",
            noStock: '库存不足',
            buyNow: '立即购买',
            generatePwd: '随机生成密码',
            randomPasswordTip1: '1、密码用于远程登录连接服务器的凭证，请妥善保存。',
            randomPasswordTip2: '2、打开小眼睛，支持复制密码。',
            randomPasswordTip3: '3、若要修改密码，请通过操作-重置密码即可。',
        },
        tips: {
            deleteVpc: "如需删除请提交工单",
            createTip: "点击创建游戏即可快速部署",
        },
        action: {
            resettingPassword: '重置密码中',
            backCPSGameListText: '更多地域',
        }
    }
};



// WEBPACK FOOTER //
// ./src/common/i18n/en-US.js